/*
 * Favorieten op de hele site (Thomas, 4 nov 2026).
 *
 * De lijsten zelf komen uit de Collectie Lijst en de favorietenpagina (thema 5.0): drie lijsten in de browser,
 * localStorage sentir-fav / sentir-try / sentir-no (product-id's) plus sentir-handles (id -> handle). Dit bestand
 * doet drie dingen eromheen:
 *
 *  1. Het hartje in de header (sections/header.liquid, [data-nav-fav]) met het aantal favorieten. Het hartje
 *     verschijnt pas als er iets bewaard is, zodat het niemand in de weg zit die de lijsten niet gebruikt.
 *     Op de site staat alleen het hartje aan; to-try en 'Niet mijn match' staan uit (Thomas, 4 nov 2026). Die twee
 *     lijsten gaan hier wel gewoon mee naar het account, zodat er niets verloren gaat als ze terugkomen.
 *  2. Een korte melding als een geur in een lijst gaat (event 'sentir:list-toast'); in 5.0 doet de header dat.
 *  3. Koppeling met het klantaccount. Een thema kan klantgegevens lezen maar niet schrijven, dus dat loopt via de
 *     app-proxy van de app Sentir Quiz: /apps/sentir/favorieten -> relay (/proxy/favorieten), die de handtekening en
 *     het ingelogde klantnummer van Shopify controleert. Zonder account blijft de lijst in deze browser; bij inloggen
 *     gaat hij mee naar het account en komt hij op elk apparaat terug. De notities (deel 4) gaan op dezelfde manier mee.
 *  4. Notities op de favorietenpagina (Thomas, 4 nov 2026): onder elke kaart een balk om een eigen notitie bij de geur
 *     te schrijven, dicht als je hem niet gebruikt. Opslag: localStorage sentir-notities ({ product-id: tekst }).
 *  5. Klaviyo (Thomas, 4 nov 2026): de gebeurtenis 'Added to Favorites' voor een opvolgflow, en de favorieten als
 *     profielgegevens (Favorieten, Favorieten_lijst, Favorieten_handles, Favorieten_aantal).
 *  6. Eigen lijsten, zoals borden op Pinterest (Thomas, 4 nov 2026): favorieten indelen in lijsten als 'Volgende
 *     bestelling' of 'Cadeau-ideeën', met kant-en-klare ideeën die met één tik een lijst maken. Opslag: localStorage
 *     sentir-favlijsten ([{ id, naam, ids, concept }]); een lijst is een deel van de favorieten.
 *
 * Samenvoegen gebeurt per geur, met de laatst gesynchroniseerde stand van dit apparaat als basis (sentir-lijsten-basis):
 * is een geur hier niet veranderd sinds de vorige keer, dan beslist het account; is hij hier wel veranderd (erbij, weg
 * of naar een andere lijst), dan wint dit apparaat. Zo komen weggehaalde geuren niet terug. De eerste keer op een
 * apparaat worden de lijsten samengevoegd. Logt hier daarna iemand anders in, dan haalt de eerste pagina eerst alles
 * van de vorige klant uit deze browser (zie opruimenNaUitloggen). Notities volgen dezelfde regel per geur. Haal je een
 * geur weg, dan blijft zijn notitie staan (ook in het account) voor als hij terugkomt. Het account heeft een
 * versienummer: wat op een oudere versie gebaseerd is, wordt eerst samengevoegd met wat het account nu heeft (deel 3),
 * nooit blind overschreven.
 */
(function () {
  'use strict';

  var LIJSTEN = ['fav', 'try', 'no'];
  var BASIS_SLEUTEL = 'sentir-lijsten-basis';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PROXY = root + 'apps/sentir/favorieten';
  var klant = document.documentElement.getAttribute('data-sentir-klant') || '';
  var NOTITIE_SLEUTEL = 'sentir-notities';
  var NOTITIE_MAX = 500; // tekens per notitie; de relay weigert langere
  var NOTITIES_MAX = 500; // notities per account; idem
  var EIGEN_SLEUTEL = 'sentir-favlijsten';
  var EIGEN_MAX = 50; // lijsten per klant; zelfde grenzen als de relay
  var EIGEN_NAAM_MAX = 60;
  var EIGEN_PER_LIJST = 200;

  /*
   * Teksten (optimalisatieronde 5 nov 2026). Het hartje, de melding en het venster komen ook op de., fr. en .com
   * (productpagina, herfstpagina), dus eigen teksten per taal in plaats van overal Nederlands. De taal komt uit het
   * subdomein, zoals bij het contactformulier; .com en andere talen krijgen Engels. Duits met "du", Frans met
   * "vous", zoals op de contactpagina. Wat de klant zelf typt (lijstnamen, notities) blijft zoals het is.
   */
  var TAAL = (function () {
    var sub = window.location.hostname.split('.')[0];
    if (/^(nl|de|fr)$/.test(sub)) return sub;
    var lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
    return /^(nl|de|fr)$/.test(lang) ? lang : 'en';
  })();
  var TEKSTEN = {
    "nl": {
      "inFav": "{naam} staat in je favorieten",
      "uitFav": "{naam} is uit je favorieten",
      "dezeGeur": "Deze geur",
      "voegToe": "Voeg toe aan lijst",
      "mijnFav": "Mijn favorieten",
      "accountTip": "Bewaar je favorieten in je account",
      "bekijkLijst": "Bekijk lijst",
      "inLijst": "{naam} staat in ‘{lijst}’",
      "inLijsten": "{naam} staat in {n} lijsten",
      "geenLijst": "{naam} staat in geen lijst meer",
      "mislukt": "Dat lukte niet. Probeer het opnieuw.",
      "verwijderd": "‘{lijst}’ is verwijderd",
      "ongedaan": "Ongedaan maken",
      "nuBijLijsten": "‘{lijst}’ staat nu bij je lijsten",
      "gekopieerd": "De link naar ‘{lijst}’ is gekopieerd. Plak hem in een bericht of mail.",
      "kopieer": "Kopieer de link:",
      "deelTekst": "Mijn lijst ‘{lijst}’ bij Sentir Parfum",
      "opslaanInLijst": "Opslaan in een lijst",
      "nieuweLijst": "Nieuwe lijst",
      "sluiten": "Sluiten",
      "jeLijsten": "Je lijsten",
      "kiesIdee": "Kies een idee",
      "ofEigenNaam": "Of kies zelf een naam",
      "kiesNaam": "Kies een naam",
      "naamNieuweLijst": "Naam van je nieuwe lijst",
      "voorbeeldNaam": "Bijv. Mijn zomergeuren",
      "maakLijst": "Maak lijst",
      "geur1": "1 geur",
      "geurN": "{n} geuren",
      "maxLijsten": "Je kunt hooguit {n} lijsten maken.",
      "lijstGemaakt": "Lijst {lijst} gemaakt",
      "inX": "In {lijst}",
      "uitX": "Uit {lijst}",
      "mijnLijsten": "Mijn lijsten",
      "alleFav": "Alle favorieten",
      "metIdeeen": "Met ideeën om te beginnen",
      "allesMand": "Alles in je winkelmand",
      "naamWijzigen": "Naam wijzigen",
      "deelLijst": "Deel lijst",
      "lijstVerwijderen": "Lijst verwijderen",
      "bewaar": "Bewaar",
      "annuleer": "Annuleer",
      "nieuweNaam": "Nieuwe naam voor deze lijst",
      "tip": "Tip: vanaf 2 geuren in reisformaat krijg je vanzelf bundelkorting: 2 geuren −20%, 3 −30%, 4 of meer −40%.",
      "leegLijst": "Nog niets in deze lijst. Tik op de knop rechtsboven bij een geur om hem hier te bewaren.",
      "eerderAccount": "Eerder favorieten bewaard in je account? ",
      "logIn": "Log in",
      "omTerug": " om ze terug te zien.",
      "lijstAria1": "In 1 lijst · lijsten aanpassen",
      "lijstAriaN": "In {n} lijsten · lijsten aanpassen",
      "gedeeldeLijst": "Gedeelde lijst",
      "gedeeldTekst": "Iemand deelde deze geuren met je. Bewaar ze als eigen lijst, of zet ze meteen in je winkelmand.",
      "bewaarAlsLijst": "Bewaar als mijn lijst",
      "verwijderFav": "Verwijder uit favorieten",
      "zetFav": "Zet bij favorieten",
      "notToevoegen": "Notitie toevoegen",
      "notOpen": "Je notitie",
      "notVoorbeeld": "Wat vind je ervan? Bijvoorbeeld: perfect voor de avond, blijft lang hangen.",
      "notPrive": "Alleen jij ziet deze notitie.",
      "notBewaard": "Bewaard",
      "notKlaar": "Klaar",
      "notBij": "Notitie bij ",
      "pdpUit": "Verwijder uit je favorieten",
      "pdpAan": "Bewaar in je favorieten",
      "pdpTitelAan": "In je favorieten",
      "c_volgende-bestelling": "Volgende bestelling",
      "c_favoriete-set": "Mijn favoriete set",
      "c_cadeau": "Cadeau-ideeën",
      "c_zomer": "Voor de zomer",
      "c_winter": "Voor de winter",
      "c_avond": "Avond & uitgaan",
      "c_elke-dag": "Voor elke dag",
      "c_proberen": "Nog proberen"
    },
    "de": {
      "inFav": "{naam} ist jetzt in deinen Favoriten",
      "uitFav": "{naam} ist nicht mehr in deinen Favoriten",
      "dezeGeur": "Dieser Duft",
      "voegToe": "Zur Liste hinzufügen",
      "mijnFav": "Meine Favoriten",
      "accountTip": "Speichere deine Favoriten in deinem Konto",
      "bekijkLijst": "Liste ansehen",
      "inLijst": "{naam} ist jetzt in „{lijst}“",
      "inLijsten": "{naam} ist in {n} Listen",
      "geenLijst": "{naam} ist in keiner Liste mehr",
      "mislukt": "Das hat nicht geklappt. Bitte versuche es noch einmal.",
      "verwijderd": "„{lijst}“ wurde gelöscht",
      "ongedaan": "Rückgängig",
      "nuBijLijsten": "„{lijst}“ ist jetzt bei deinen Listen",
      "gekopieerd": "Der Link zu „{lijst}“ wurde kopiert. Füge ihn in eine Nachricht oder E-Mail ein.",
      "kopieer": "Kopiere den Link:",
      "deelTekst": "Meine Liste „{lijst}“ bei Sentir Parfum",
      "opslaanInLijst": "In einer Liste speichern",
      "nieuweLijst": "Neue Liste",
      "sluiten": "Schließen",
      "jeLijsten": "Deine Listen",
      "kiesIdee": "Wähle eine Idee",
      "ofEigenNaam": "Oder wähle selbst einen Namen",
      "kiesNaam": "Wähle einen Namen",
      "naamNieuweLijst": "Name deiner neuen Liste",
      "voorbeeldNaam": "z. B. Meine Sommerdüfte",
      "maakLijst": "Liste erstellen",
      "geur1": "1 Duft",
      "geurN": "{n} Düfte",
      "maxLijsten": "Du kannst höchstens {n} Listen erstellen.",
      "lijstGemaakt": "Liste {lijst} erstellt",
      "inX": "In {lijst}",
      "uitX": "Aus {lijst}",
      "mijnLijsten": "Meine Listen",
      "alleFav": "Alle Favoriten",
      "metIdeeen": "Mit Ideen zum Start",
      "allesMand": "Alles in den Warenkorb",
      "naamWijzigen": "Umbenennen",
      "deelLijst": "Liste teilen",
      "lijstVerwijderen": "Liste löschen",
      "bewaar": "Speichern",
      "annuleer": "Abbrechen",
      "nieuweNaam": "Neuer Name für diese Liste",
      "tip": "Tipp: Ab 2 Düften im Reiseformat bekommst du automatisch Bundle-Rabatt: 2 Düfte −20 %, 3 −30 %, ab 4 −40 %.",
      "leegLijst": "Noch nichts in dieser Liste. Tippe bei einem Duft oben rechts auf den Knopf, um ihn hier zu speichern.",
      "eerderAccount": "Schon Favoriten in deinem Konto gespeichert? ",
      "logIn": "Melde dich an",
      "omTerug": ", um sie wiederzusehen.",
      "lijstAria1": "In 1 Liste · Listen anpassen",
      "lijstAriaN": "In {n} Listen · Listen anpassen",
      "gedeeldeLijst": "Geteilte Liste",
      "gedeeldTekst": "Jemand hat diese Düfte mit dir geteilt. Speichere sie als eigene Liste oder lege sie direkt in den Warenkorb.",
      "bewaarAlsLijst": "Als meine Liste speichern",
      "verwijderFav": "Aus den Favoriten entfernen",
      "zetFav": "Zu den Favoriten",
      "notToevoegen": "Notiz hinzufügen",
      "notOpen": "Deine Notiz",
      "notVoorbeeld": "Wie findest du ihn? Zum Beispiel: perfekt für den Abend, hält lange.",
      "notPrive": "Nur du siehst diese Notiz.",
      "notBewaard": "Gespeichert",
      "notKlaar": "Fertig",
      "notBij": "Notiz zu ",
      "pdpUit": "Aus deinen Favoriten entfernen",
      "pdpAan": "In deinen Favoriten speichern",
      "pdpTitelAan": "In deinen Favoriten",
      "c_volgende-bestelling": "Nächste Bestellung",
      "c_favoriete-set": "Mein Lieblingsset",
      "c_cadeau": "Geschenkideen",
      "c_zomer": "Für den Sommer",
      "c_winter": "Für den Winter",
      "c_avond": "Abend & Ausgehen",
      "c_elke-dag": "Für jeden Tag",
      "c_proberen": "Noch ausprobieren"
    },
    "fr": {
      "inFav": "{naam} est dans vos favoris",
      "uitFav": "{naam} a été retiré de vos favoris",
      "dezeGeur": "Ce parfum",
      "voegToe": "Ajouter à une liste",
      "mijnFav": "Mes favoris",
      "accountTip": "Enregistrez vos favoris dans votre compte",
      "bekijkLijst": "Voir la liste",
      "inLijst": "{naam} est dans « {lijst} »",
      "inLijsten": "{naam} est dans {n} listes",
      "geenLijst": "{naam} n’est plus dans aucune liste",
      "mislukt": "Cela n’a pas fonctionné. Veuillez réessayer.",
      "verwijderd": "« {lijst} » a été supprimée",
      "ongedaan": "Annuler",
      "nuBijLijsten": "« {lijst} » est maintenant dans vos listes",
      "gekopieerd": "Le lien vers « {lijst} » a été copié. Collez-le dans un message ou un e-mail.",
      "kopieer": "Copiez le lien :",
      "deelTekst": "Ma liste « {lijst} » chez Sentir Parfum",
      "opslaanInLijst": "Enregistrer dans une liste",
      "nieuweLijst": "Nouvelle liste",
      "sluiten": "Fermer",
      "jeLijsten": "Vos listes",
      "kiesIdee": "Choisissez une idée",
      "ofEigenNaam": "Ou choisissez vous-même un nom",
      "kiesNaam": "Choisissez un nom",
      "naamNieuweLijst": "Nom de votre nouvelle liste",
      "voorbeeldNaam": "Ex. : Mes parfums d’été",
      "maakLijst": "Créer la liste",
      "geur1": "1 parfum",
      "geurN": "{n} parfums",
      "maxLijsten": "Vous pouvez créer au maximum {n} listes.",
      "lijstGemaakt": "Liste {lijst} créée",
      "inX": "Dans {lijst}",
      "uitX": "Retiré de {lijst}",
      "mijnLijsten": "Mes listes",
      "alleFav": "Tous les favoris",
      "metIdeeen": "Avec des idées pour commencer",
      "allesMand": "Tout ajouter au panier",
      "naamWijzigen": "Renommer",
      "deelLijst": "Partager la liste",
      "lijstVerwijderen": "Supprimer la liste",
      "bewaar": "Enregistrer",
      "annuleer": "Annuler",
      "nieuweNaam": "Nouveau nom pour cette liste",
      "tip": "Astuce : dès 2 parfums en format voyage, vous profitez automatiquement de la remise lot : 2 parfums −20 %, 3 −30 %, 4 ou plus −40 %.",
      "leegLijst": "Rien dans cette liste pour l’instant. Touchez le bouton en haut à droite d’un parfum pour l’enregistrer ici.",
      "eerderAccount": "Vous avez déjà enregistré des favoris dans votre compte ? ",
      "logIn": "Connectez-vous",
      "omTerug": " pour les retrouver.",
      "lijstAria1": "Dans 1 liste · modifier les listes",
      "lijstAriaN": "Dans {n} listes · modifier les listes",
      "gedeeldeLijst": "Liste partagée",
      "gedeeldTekst": "Quelqu’un a partagé ces parfums avec vous. Enregistrez-les comme votre propre liste ou ajoutez-les directement au panier.",
      "bewaarAlsLijst": "Enregistrer comme ma liste",
      "verwijderFav": "Retirer des favoris",
      "zetFav": "Ajouter aux favoris",
      "notToevoegen": "Ajouter une note",
      "notOpen": "Votre note",
      "notVoorbeeld": "Qu’en pensez-vous ? Par exemple : parfait pour le soir, tient longtemps.",
      "notPrive": "Vous seul voyez cette note.",
      "notBewaard": "Enregistré",
      "notKlaar": "Terminé",
      "notBij": "Note pour ",
      "pdpUit": "Retirer de vos favoris",
      "pdpAan": "Enregistrer dans vos favoris",
      "pdpTitelAan": "Dans vos favoris",
      "c_volgende-bestelling": "Prochaine commande",
      "c_favoriete-set": "Mon coffret favori",
      "c_cadeau": "Idées cadeaux",
      "c_zomer": "Pour l’été",
      "c_winter": "Pour l’hiver",
      "c_avond": "Soirée & sorties",
      "c_elke-dag": "Pour tous les jours",
      "c_proberen": "À essayer"
    },
    "en": {
      "inFav": "{naam} is in your favourites",
      "uitFav": "{naam} was removed from your favourites",
      "dezeGeur": "This scent",
      "voegToe": "Add to list",
      "mijnFav": "My favourites",
      "accountTip": "Save your favourites to your account",
      "bekijkLijst": "View list",
      "inLijst": "{naam} is in ‘{lijst}’",
      "inLijsten": "{naam} is in {n} lists",
      "geenLijst": "{naam} is no longer in any list",
      "mislukt": "That didn’t work. Please try again.",
      "verwijderd": "‘{lijst}’ was deleted",
      "ongedaan": "Undo",
      "nuBijLijsten": "‘{lijst}’ is now in your lists",
      "gekopieerd": "The link to ‘{lijst}’ was copied. Paste it into a message or email.",
      "kopieer": "Copy the link:",
      "deelTekst": "My list ‘{lijst}’ at Sentir Parfum",
      "opslaanInLijst": "Save to a list",
      "nieuweLijst": "New list",
      "sluiten": "Close",
      "jeLijsten": "Your lists",
      "kiesIdee": "Pick an idea",
      "ofEigenNaam": "Or choose your own name",
      "kiesNaam": "Choose a name",
      "naamNieuweLijst": "Name of your new list",
      "voorbeeldNaam": "E.g. My summer scents",
      "maakLijst": "Create list",
      "geur1": "1 scent",
      "geurN": "{n} scents",
      "maxLijsten": "You can create up to {n} lists.",
      "lijstGemaakt": "List {lijst} created",
      "inX": "In {lijst}",
      "uitX": "Removed from {lijst}",
      "mijnLijsten": "My lists",
      "alleFav": "All favourites",
      "metIdeeen": "With ideas to get started",
      "allesMand": "Add all to cart",
      "naamWijzigen": "Rename",
      "deelLijst": "Share list",
      "lijstVerwijderen": "Delete list",
      "bewaar": "Save",
      "annuleer": "Cancel",
      "nieuweNaam": "New name for this list",
      "tip": "Tip: from 2 travel-size scents you automatically get a bundle discount: 2 scents −20%, 3 −30%, 4 or more −40%.",
      "leegLijst": "Nothing in this list yet. Tap the button at the top right of a scent to save it here.",
      "eerderAccount": "Saved favourites to your account before? ",
      "logIn": "Log in",
      "omTerug": " to see them again.",
      "lijstAria1": "In 1 list · edit lists",
      "lijstAriaN": "In {n} lists · edit lists",
      "gedeeldeLijst": "Shared list",
      "gedeeldTekst": "Someone shared these scents with you. Save them as your own list, or add them straight to your cart.",
      "bewaarAlsLijst": "Save as my list",
      "verwijderFav": "Remove from favourites",
      "zetFav": "Add to favourites",
      "notToevoegen": "Add a note",
      "notOpen": "Your note",
      "notVoorbeeld": "What do you think? For example: perfect for the evening, lasts long.",
      "notPrive": "Only you can see this note.",
      "notBewaard": "Saved",
      "notKlaar": "Done",
      "notBij": "Note for ",
      "pdpUit": "Remove from your favourites",
      "pdpAan": "Save to your favourites",
      "pdpTitelAan": "In your favourites",
      "c_volgende-bestelling": "Next order",
      "c_favoriete-set": "My favourite set",
      "c_cadeau": "Gift ideas",
      "c_zomer": "For summer",
      "c_winter": "For winter",
      "c_avond": "Evenings out",
      "c_elke-dag": "For every day",
      "c_proberen": "To try"
    }
  };

  // Extra teksten (review 5 nov), per taal in dezelfde volgorde nl/de/fr/en.
  [
    ['tryIn', '{naam} staat op je to-try lijst', '{naam} steht auf deiner To-try-Liste', '{naam} est dans votre liste à essayer', '{naam} is on your to-try list'],
    ['tryUit', '{naam} is van je to-try lijst', '{naam} ist nicht mehr auf deiner To-try-Liste', '{naam} a été retiré de votre liste à essayer', '{naam} was removed from your to-try list'],
    ['noIn', '{naam} staat nu bij ‘Niet mijn match’', '{naam} steht jetzt bei „Nicht mein Match“', '{naam} est maintenant dans « Pas pour moi »', '{naam} is now in ‘Not my match’'],
    ['noUit', '{naam} staat niet meer bij ‘Niet mijn match’', '{naam} steht nicht mehr bei „Nicht mein Match“', '{naam} n’est plus dans « Pas pour moi »', '{naam} is no longer in ‘Not my match’'],
    ['favoriet', 'Favoriet', 'Favorit', 'Favori', 'Favourite'],
    ['lijstVol', '‘{lijst}’ is vol (hooguit {n} geuren)', '„{lijst}“ ist voll (höchstens {n} Düfte)', '« {lijst} » est pleine ({n} parfums maximum)', '‘{lijst}’ is full (up to {n} scents)'],
    ['zekerWeg', 'Lijst ‘{lijst}’ verwijderen?', 'Liste „{lijst}“ löschen?', 'Supprimer la liste « {lijst} » ?', 'Delete the list ‘{lijst}’?'],
    ['jaWeg', 'Ja, verwijder', 'Ja, löschen', 'Oui, supprimer', 'Yes, delete'],
    ['opslaanBij', 'Opslaan in een lijst: {naam}', 'In einer Liste speichern: {naam}', 'Enregistrer dans une liste : {naam}', 'Save to a list: {naam}'],
    ['lijstAria1Bij', '{naam}: in 1 lijst, lijsten aanpassen', '{naam}: in 1 Liste, Listen anpassen', '{naam} : dans 1 liste, modifier les listes', '{naam}: in 1 list, edit lists'],
    ['lijstAriaNBij', '{naam}: in {n} lijsten, lijsten aanpassen', '{naam}: in {n} Listen, Listen anpassen', '{naam} : dans {n} listes, modifier les listes', '{naam}: in {n} lists, edit lists'],
    ['mijnFavN', 'Mijn favorieten ({n})', 'Meine Favoriten ({n})', 'Mes favoris ({n})', 'My favourites ({n})'],
  ].forEach(function (rij) {
    ['nl', 'de', 'fr', 'en'].forEach(function (taal, i) { TEKSTEN[taal][rij[0]] = rij[i + 1]; });
  });

  function t(sleutel, waarden) {
    var tekst = (TEKSTEN[TAAL] && TEKSTEN[TAAL][sleutel]) || TEKSTEN.nl[sleutel] || sleutel;
    Object.keys(waarden || {}).forEach(function (k) { tekst = tekst.split('{' + k + '}').join(String(waarden[k])); });
    return tekst;
  }

  function lees(sleutel, standaard) {
    try {
      var waarde = JSON.parse(window.localStorage.getItem(sleutel) || 'null');
      return waarde == null ? standaard : waarde;
    } catch (fout) {
      return standaard;
    }
  }

  function zet(sleutel, waarde) {
    try {
      window.localStorage.setItem(sleutel, JSON.stringify(waarde));
    } catch (fout) { /* opslag vol of geblokkeerd: dan alleen deze pagina */ }
  }

  /* De drie lijsten als { lijst: [id, ...] } en als { id: lijst }. */
  function leesLijsten() {
    var uit = {};
    LIJSTEN.forEach(function (k) {
      var lijst = lees('sentir-' + k, []);
      uit[k] = Array.isArray(lijst) ? lijst.map(String) : [];
    });
    return uit;
  }

  function perGeur(lijsten) {
    var map = {};
    LIJSTEN.forEach(function (k) {
      (lijsten[k] || []).forEach(function (id) {
        id = String(id);
        if (!map[id]) map[id] = k;
      });
    });
    return map;
  }

  /* Notities als { id: tekst }: alleen tekst, hooguit NOTITIE_MAX tekens, geen lege. */
  function schoneNotities(ruw) {
    var uit = {};
    if (ruw && typeof ruw === 'object' && !Array.isArray(ruw)) {
      Object.keys(ruw).forEach(function (id) {
        var tekst = ruw[id];
        if (/^\d{1,20}$/.test(id) && typeof tekst === 'string' && tekst.trim()) uit[id] = tekst.slice(0, NOTITIE_MAX);
      });
    }
    return uit;
  }

  function leesNotities() {
    return schoneNotities(lees(NOTITIE_SLEUTEL, {}));
  }

  /* Eigen lijsten als [{ id, naam, ids, concept? }]: geldige id's en namen, geen dubbele, binnen de grenzen. */
  function schoneEigen(ruw) {
    var uit = [];
    var gezien = {};
    (Array.isArray(ruw) ? ruw : []).forEach(function (lijst) {
      if (!lijst || typeof lijst !== 'object' || uit.length >= EIGEN_MAX) return;
      var id = String(lijst.id || '');
      var naam = typeof lijst.naam === 'string' ? lijst.naam.trim().slice(0, EIGEN_NAAM_MAX) : '';
      if (!/^[a-z0-9_-]{1,40}$/.test(id) || !naam || gezien[id]) return;
      gezien[id] = 1;
      var ids = [];
      (Array.isArray(lijst.ids) ? lijst.ids : []).forEach(function (pid) {
        pid = String(pid);
        if (/^\d{1,20}$/.test(pid) && ids.indexOf(pid) < 0 && ids.length < EIGEN_PER_LIJST) ids.push(pid);
      });
      var schoon = { id: id, naam: naam, ids: ids };
      if (typeof lijst.concept === 'string' && /^[a-z0-9-]{1,40}$/.test(lijst.concept)) schoon.concept = lijst.concept;
      uit.push(schoon);
    });
    return uit;
  }

  function leesEigen() {
    return schoneEigen(lees(EIGEN_SLEUTEL, []));
  }

  function zetEigen(lijsten) {
    zet(EIGEN_SLEUTEL, schoneEigen(lijsten));
    try { window.dispatchEvent(new CustomEvent('sentir:favlijsten-changed')); } catch (fout) {}
  }

  /* Een eigen lijst toont alleen geuren die (nog) favoriet zijn. Wie een hartje uitzet en weer aan, of 'Ongedaan maken'
   * gebruikt, houdt zo zijn indeling: de lijst zelf wordt niet gesnoeid, alleen bij het tonen en versturen gefilterd. */
  function gelijsteIds(lijst, perId) {
    var favorieten = perId || perGeur(leesLijsten());
    return lijst.ids.filter(function (pid) { return favorieten[pid]; });
  }

  /* ------------------------------------------------------------ 1. hartje -- */

  function tekenHartje() {
    var lijsten = leesLijsten();
    var aantal = lijsten.fav.length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-nav-fav]'), function (link) {
      link.hidden = aantal === 0;
      if (aantal) link.setAttribute('aria-label', t('mijnFavN', { n: aantal }));
      var teller = link.querySelector('[data-nav-fav-teller]');
      if (teller) {
        teller.textContent = aantal > 99 ? '99+' : String(aantal);
        teller.hidden = aantal === 0;
      }
    });
  }

  /* ----------------------------------------------------------- 2. melding -- */

  var meldingEl = null;
  var meldingTimer = 0;
  var accountTipGetoond = false;

  /* Toetsenbord (review 5 nov): wie een hartje met Enter of spatie gebruikt, komt met de focus op de eerste knop van de
   * melding ('Voeg toe aan lijst'). Esc, of met Tab voorbij de eerste of laatste knop, sluit de melding en zet de focus
   * terug waar hij was. De melding staat onderaan de pagina en was met Tab niet op tijd te bereiken. Met muis of
   * vinger verandert er niets. */
  var toetsMoment = 0;
  var meldingTerug = null;
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') toetsMoment = Date.now();
  }, true);
  document.addEventListener('pointerdown', function () { toetsMoment = 0; }, true);

  /* De favorietenpagina: de link van het kop-hartje (Weglot zet daar het vertaalde pad in), anders het gewone pad. */
  function favorietenUrl(lijstId) {
    var link = document.querySelector('a[data-nav-fav]');
    var url = (link && link.getAttribute('href')) || root + 'pages/favorieten';
    return lijstId ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'lijst=' + encodeURIComponent(lijstId) : url;
  }

  function verbergMelding() {
    if (!meldingEl) return;
    var hadFocus = meldingEl.contains(document.activeElement);
    meldingEl.classList.remove('is-zichtbaar');
    // Weg is ook echt weg: niet meer in de tabvolgorde of de toegankelijkheidsboom (review 5 nov).
    meldingEl.inert = true;
    if (hadFocus && meldingTerug && document.contains(meldingTerug) && meldingTerug.focus) meldingTerug.focus({ preventScroll: true });
    meldingTerug = null;
  }

  /* Bij het starten al aanmaken: een role=status die pas met tekst in de pagina komt, wordt vaak niet voorgelezen. */
  function maakMeldingEl() {
    if (meldingEl || !document.body || typeof document.createElement !== 'function') return;
    meldingEl = document.createElement('div');
    meldingEl.className = 'sentir-fav-melding wg-notranslate';
    meldingEl.setAttribute('translate', 'no');
    meldingEl.setAttribute('data-wg-notranslate', '');
    meldingEl.setAttribute('role', 'status');
    meldingEl.inert = true;
    ['mouseenter', 'focusin'].forEach(function (naam) {
      meldingEl.addEventListener(naam, function () { window.clearTimeout(meldingTimer); });
    });
    ['mouseleave', 'focusout'].forEach(function (naam) {
      meldingEl.addEventListener(naam, function () { planVerbergen(2500); });
    });
    meldingEl.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        verbergMelding();
        return;
      }
      if (event.key !== 'Tab' || !meldingTerug) return;
      var knoppen = meldingEl.querySelectorAll('.sentir-fav-melding__actie, .sentir-fav-melding__tip a');
      var eerste = knoppen[0];
      var laatste = knoppen[knoppen.length - 1];
      if ((!event.shiftKey && document.activeElement === laatste) || (event.shiftKey && document.activeElement === eerste)) {
        event.preventDefault();
        verbergMelding();
      }
    });
    document.body.appendChild(meldingEl);
  }

  /* Het zichtbare hartje van een geur (voor de focus na het venster, als het vanuit de melding opende). */
  function hartVan(pid) {
    var harten = document.querySelectorAll('.pcard[data-card="' + pid + '"] [data-mark="fav"], .sentir-pdp-hart');
    for (var i = 0; i < harten.length; i++) if (harten[i].offsetParent !== null) return harten[i];
    return null;
  }

  function planVerbergen(ms) {
    window.clearTimeout(meldingTimer);
    meldingTimer = window.setTimeout(verbergMelding, ms);
  }

  /*
   * opties (allemaal optioneel):
   *  - acties: [{ label, doe(knop) } of { label, href }]: knoppen onder de tekst, bijv. 'Voeg toe aan lijst' en
   *    'Mijn favorieten' na een hartje (Thomas, 4 nov 2026);
   *  - accountTip: true: een regel 'Bewaar je favorieten in je account' (zonder account, één keer per bezoek).
   * Met knoppen blijft de melding langer staan, en niet zolang de muis of de focus erop staat.
   */
  function melding(tekst, opties) {
    opties = opties || {};
    maakMeldingEl();
    if (!meldingEl) return;
    meldingEl.inert = false;
    meldingEl.textContent = '';
    var zin = document.createElement('p');
    zin.className = 'sentir-fav-melding__tekst';
    zin.textContent = tekst;
    meldingEl.appendChild(zin);
    var acties = opties.acties || [];
    if (acties.length) {
      var rij = document.createElement('div');
      rij.className = 'sentir-fav-melding__acties';
      acties.forEach(function (actie) {
        var el;
        if (actie.href) {
          el = document.createElement('a');
          el.href = actie.href;
        } else {
          el = document.createElement('button');
          el.type = 'button';
          el.addEventListener('click', function () {
            verbergMelding();
            actie.doe(el);
          });
        }
        el.className = 'sentir-fav-melding__actie';
        el.textContent = actie.label;
        rij.appendChild(el);
      });
      meldingEl.appendChild(rij);
    }
    if (opties.accountTip) {
      var tip = document.createElement('p');
      tip.className = 'sentir-fav-melding__tip';
      var link = document.createElement('a');
      // Na het inloggen terug naar deze pagina (Shopify volgt checkout_url, ook bij de klassieke klantaccounts).
      var login = (window.routes && window.routes.account_login_url) || root + 'account/login';
      link.href = login + (login.indexOf('?') > -1 ? '&' : '?') + 'checkout_url=' + encodeURIComponent(window.location.pathname + window.location.search);
      link.textContent = t('accountTip');
      tip.appendChild(link);
      meldingEl.appendChild(tip);
    }
    plaatsMelding();
    meldingEl.classList.add('is-zichtbaar');
    planVerbergen(acties.length || opties.accountTip ? 6000 : 2600);
    // Kort na Enter of spatie op een knop (de naam van de geur kan eerst nog opgehaald worden): focus naar de melding.
    var nu = document.activeElement;
    var knop = meldingEl.querySelector('.sentir-fav-melding__actie, .sentir-fav-melding__tip a');
    if (knop && Date.now() - toetsMoment < 3000 && nu && nu !== document.body && !meldingEl.contains(nu) &&
        !/^(INPUT|TEXTAREA|SELECT)$/.test(nu.tagName) && !nu.isContentEditable) {
      meldingTerug = nu;
      toetsMoment = 0;
      knop.focus({ preventScroll: true });
    }
  }

  /* Net onder de kop als die in beeld is, anders 16px van boven: zo bedekt de melding geen menu-items of iconen van de
     nieuwe navigatie (de vaste 9,2rem viel over het menu). De kop schuift weg bij omlaag scrollen (sticky-header). */
  function plaatsMelding() {
    var kop = document.getElementById('shopify-section-header');
    var onder = 0;
    if (kop && !kop.classList.contains('shopify-section-header-hidden')) {
      var r = kop.getBoundingClientRect();
      if (r.bottom > 0) onder = r.bottom;
    }
    meldingEl.style.top = Math.max(16, Math.round(onder + 12)) + 'px';
  }

  /* De naam zoals hij op de kaart staat: op nl. vertaald door Weglot ("Herfstset voor heren"), in het event Engels. */
  function zichtbareNaam(titel) {
    if (!titel) return '';
    try {
      var sleutel = window.CSS && window.CSS.escape ? window.CSS.escape(titel) : titel.replace(/["\\]/g, '\\$&');
      var kaart = document.querySelector('.pcard[data-title="' + sleutel + '"]');
      var kop = kaart && kaart.querySelector('h2, h3');
      if (kop && kop.textContent.trim()) return kop.textContent.trim();
    } catch (fout) {}
    return titel;
  }

  window.addEventListener('sentir:list-toast', function (event) {
    var d = (event && event.detail) || {};
    var naam = d.title ? zichtbareNaam(d.title) + ' ' : '';
    var tekst;
    // Op de favorietenpagina toont de pagina zelf een balk met 'Ongedaan maken' bij weghalen: geen tweede melding.
    if (d.added === false && document.querySelector('[data-favpage]')) return;
    var wie = naam.trim() || t('dezeGeur');
    if (d.list === 'no') tekst = t(d.added === false ? 'noUit' : 'noIn', { naam: wie });
    else if (d.list === 'try') tekst = t(d.added === false ? 'tryUit' : 'tryIn', { naam: wie });
    else tekst = d.added === false ? t('uitFav', { naam: wie }) : t('inFav', { naam: wie });
    tekst = tekst.charAt(0).toUpperCase() + tekst.slice(1);
    // Zonder account één keer per bezoek de tip om de lijst te bewaren.
    var tip = !klant && d.added !== false && d.list !== 'no' && !accountTipGetoond;
    if (tip) accountTipGetoond = true;
    // Net een hartje gezet: meteen in een eigen lijst kunnen zetten (deel 6), en door naar de favorieten.
    var acties = [];
    if (d.list === 'fav' && d.added !== false) {
      var pid = idBijTitel(d.title);
      if (pid) acties.push({ label: t('voegToe'), doe: function () { openBlad(pid, hartVan(pid)); } });
      if (!document.querySelector('[data-favpage]')) acties.push({ label: t('mijnFav'), href: favorietenUrl() });
    }
    melding(tekst, { acties: acties, accountTip: tip });
  });

  function idBijTitel(titel) {
    if (!titel) return '';
    try {
      var sleutel = window.CSS && window.CSS.escape ? window.CSS.escape(titel) : titel.replace(/["\\]/g, '\\$&');
      var kaart = document.querySelector('.pcard[data-title="' + sleutel + '"][data-card]');
      return kaart ? kaart.getAttribute('data-card') : '';
    } catch (fout) {
      return '';
    }
  }

  /* ---------------------------------------------------- 3. klantaccount -- */

  /*
   * Versie 2 (5 nov 2026, na de tweede review): compare-and-set. Het account heeft een versienummer dat bij elke opslag
   * één hoger wordt. De basis (sentir-lijsten-basis) bewaart dat nummer samen met de stand die het account aantoonbaar
   * heeft: uit een GET, een geslaagde POST of een 409. Een POST zegt op welke versie hij gebaseerd is. Is het account
   * intussen verder (een ander apparaat, of een tab die uren open stond), dan slaat de relay niets op (409) en stuurt
   * hij de huidige stand mee; die wordt hier samengevoegd zoals bij het laden, en dan gaat de POST opnieuw (hooguit 3
   * rondes). Zo overschrijft een oude pagina nooit meer wat elders veranderde.
   * Per tabblad loopt er één verzoek tegelijk; wat er intussen bij komt, wacht tot dat klaar is.
   * Na de review van sync v2: elke POST heeft een nummer en de relay zegt welke hij opsloeg (toegepast), zodat een POST
   * waarvan het antwoord nooit aankwam niet meer geraden hoeft te worden (zie herzieBasis). De pagina zegt bij elk
   * verzoek voor welke klant ze gemaakt is; een tabblad van een andere klant krijgt van de relay niets (403).
   */
  var KOPPEL_URL = PROXY + '?klant=' + encodeURIComponent(klant);
  var bezig = 0; // Date.now() waarop het lopende verzoek begon, 0 als er niets loopt
  var beurt = 0;
  var nogEens = ''; // wat er na het lopende verzoek nog moet: 'koppel' of 'zend'
  var zendTimer = 0;
  var koppelTimer = 0;
  var pogingen = 0; // mislukte GETs na elkaar
  var herhaald = 0; // GET-antwoorden die ouder waren dan de basis
  var laatsteSync = 0; // laatste antwoord van het account (Date.now())
  var laatstePoging = 0; // laatste GET, ook als die mislukte (geen nieuwe reeks bij elke tabwissel)
  var relayFout = false; // de laatste GET van deze pagina mislukte (zie startFlush)
  var VERS = 5 * 60 * 1000; // ouder dan dit: bij terugkeer naar de tab eerst opnieuw ophalen
  var HANGT = 30 * 1000; // een verzoek dat na 30 s nog loopt, houdt de volgende niet meer op

  function naarLijsten(map, volgorde) {
    var uit = { fav: [], 'try': [], no: [] };
    var gezien = {};
    volgorde.forEach(function (id) {
      if (gezien[id] || !map[id]) return;
      gezien[id] = 1;
      uit[map[id]].push(id);
    });
    return uit;
  }

  /* Volgorde (review 5 nov): die van het account, met wat hier nieuw is erachter (zoals maakFavoriet het toevoegt).
   * Zo krijgen alle apparaten dezelfde volgorde en POSTen ze niet bij elke pagina hun eigen volgorde. */
  function samenvoegen(lokaal, server, basis, alleenNieuw) {
    var l = perGeur(lokaal);
    var s = perGeur(server);
    var uit = {};
    var ids = {};
    [l, s, basis].forEach(function (m) {
      Object.keys(m).forEach(function (id) { ids[id] = 1; });
    });
    Object.keys(ids).forEach(function (id) {
      if (alleenNieuw) {
        // Andere klant dan bij de vorige synchronisatie: alleen wat hier sindsdien bij kwam gaat mee.
        uit[id] = s[id] || (!basis[id] && l[id]) || undefined;
      } else {
        uit[id] = l[id] === basis[id] ? s[id] : l[id];
      }
      if (!uit[id]) delete uit[id];
    });
    var volgorde = [];
    LIJSTEN.forEach(function (k) {
      volgorde = volgorde.concat(server[k] || [], lokaal[k] || []);
    });
    return naarLijsten(uit, volgorde);
  }

  function gelijk(a, b) {
    return LIJSTEN.every(function (k) {
      return JSON.stringify(a[k] || []) === JSON.stringify(b[k] || []);
    });
  }

  /* Zelfde regel als bij de lijsten, per geur: is de notitie hier niet veranderd sinds de vorige synchronisatie, dan
   * beslist het account; anders wint dit apparaat (ook als hij hier is leeggemaakt). Sinds versie 2 bewaart het account
   * ook de notitie bij een geur die in geen lijst (meer) staat, dus zonder uitzonderingen; de eerste keer (geen basis)
   * wint zo vanzelf de notitie die hier net getypt is. */
  /*
   * basisLijsten / lokaalLijsten: { id: lijst } van de vorige synchronisatie en van dit apparaat. Ander account (review
   * 5 nov): alleen de notitie van een geur die hier sindsdien NIEUW bij kwam gaat mee, nooit een achtergebleven notitie
   * van het vorige account (privé).
   */
  function samenvoegenNotities(lokaal, server, basis, alleenNieuw, basisLijsten, lokaalLijsten) {
    basisLijsten = basisLijsten || {};
    lokaalLijsten = lokaalLijsten || {};
    var uit = {};
    var ids = {};
    [lokaal, server, basis].forEach(function (m) {
      Object.keys(m).forEach(function (id) { ids[id] = 1; });
    });
    Object.keys(ids).forEach(function (id) {
      var tekst;
      if (alleenNieuw) tekst = server[id] || (!basisLijsten[id] && lokaalLijsten[id] ? lokaal[id] : undefined);
      else tekst = lokaal[id] === basis[id] ? server[id] : lokaal[id];
      if (tekst) uit[id] = tekst;
    });
    return uit;
  }

  /* Eigen lijsten. Een hier verwijderde lijst blijft weg, een lijst die alleen op een ander apparaat bestaat komt erbij.
   * Bestaat een lijst aan beide kanten, dan per onderdeel (review 5 nov): de naam volgens dezelfde regel, en de geuren
   * per geur, zodat twee apparaten die elk iets aan dezelfde lijst toevoegen allebei hun geur houden. Volgorde: wat hier
   * nieuw is vooraan (zoals maakLijst en zetInLijst het neerzetten), daarna die van het account. Een lijst die hier
   * nieuw is met dezelfde naam als een lijst van het account die hier nog niet staat, wordt die lijst; anders staat
   * 'Volgende bestelling' er na het inloggen twee keer (review 5 nov). Met hetzelfde idee alleen als een van de twee nog
   * zo heet als dat idee, en dan met de naam die iemand zelf koos: twee hernoemde lijsten van één idee ('Voor mama',
   * 'Voor papa') blijven twee lijsten (review sync v2, ronde 2). gelijst / basisGelijst: { id: lijst } na het
   * samenvoegen en bij de vorige synchronisatie (zie hierAangevuld). */
  function samenvoegenEigen(lokaal, server, basis, alleenNieuw, gelijst, basisGelijst, onthouden) {
    function perId(lijsten) {
      var map = {};
      lijsten.forEach(function (lijst) { map[lijst.id] = lijst; });
      return map;
    }
    function alleenGelijst(lijst) {
      return gelijst ? Object.assign({}, lijst, { ids: lijst.ids.filter(function (pid) { return gelijst[pid]; }) }) : lijst;
    }
    var s = perId(server);
    var b = perId(basis);
    if (!alleenNieuw) {
      var bezet = perId(lokaal);
      lokaal = lokaal.map(function (L) {
        if (s[L.id] || b[L.id]) return L;
        var zelfde = server.filter(function (S) {
          return !bezet[S.id] && (S.naam.toLowerCase() === L.naam.toLowerCase() ||
            (!!L.concept && S.concept === L.concept && (ideeNaam(L) || ideeNaam(S))));
        })[0];
        if (!zelfde) return L;
        bezet[zelfde.id] = 1;
        // niet terug naar de naam van het idee
        return Object.assign({}, L, { id: zelfde.id, naam: ideeNaam(zelfde) && !ideeNaam(L) ? L.naam : zelfde.naam });
      });
    }
    var l = perId(lokaal);
    var volgorde = [];
    lokaal.filter(function (lijst) { return !s[lijst.id]; }).concat(server).forEach(function (lijst) {
      if (volgorde.indexOf(lijst.id) < 0) volgorde.push(lijst.id);
    });
    var uit = [];
    volgorde.forEach(function (id) {
      var L = l[id], S = s[id], B = b[id];
      var keuze;
      if (alleenNieuw) keuze = S || (B === undefined ? L : undefined);
      else if (L && S) keuze = samenvoegenLijst(L, S, B);
      else if (L && B) keuze = hierAangevuld(alleenGelijst(L), alleenGelijst(B), basisGelijst, onthouden && (onthouden[id] || [])) ? L : undefined; // elders weg
      else keuze = B ? undefined : L || S; // hier verwijderd, of aan één kant nieuw
      // Ook hier alleen geuren die na het samenvoegen favoriet zijn, zoals het account ze bewaart. Anders bleef een geur
      // van elders hier onzichtbaar in de lijst staan en kwam hij met een nieuw hartje terug als 'wijziging hier', ook in
      // een lijst die elders was verwijderd (review sync v2).
      if (keuze) uit.push(JSON.parse(JSON.stringify(alleenGelijst(keuze))));
    });
    return uit;
  }

  /* Elders verwijderd: de lijst blijft alleen als hij hier veranderde, en dan alleen door een andere naam of idee of een
   * geur erbij. Een geur eruit past bij verwijderen (review sync v2: anders kwam een lijst terug omdat een geur er bij
   * een samenvoeging uit viel toen hij hier even geen favoriet was). Alleen geuren die na het samenvoegen favoriet zijn
   * tellen mee (zie alleenGelijst). Een geur die met een nieuw hartje vanzelf in zijn oude lijst terugkomt (de lijst
   * onthoudt hem), is geen wijziging van die lijst. Weet de basis welke geuren de lijst hier toen alleen nog onthield
   * (onthouden, zie stuur), dan telt elke andere geur erbij, ook een nieuwe favoriet die hier bewust in de lijst is
   * gezet (review sync v2, ronde 2: die viel anders stil weg). Weet de basis dat niet, dan alleen geuren die bij de
   * vorige synchronisatie al favoriet waren. */
  function hierAangevuld(L, B, basisGelijst, onthouden) {
    return L.naam !== B.naam || (L.concept || '') !== (B.concept || '') ||
      L.ids.some(function (pid) {
        if (B.ids.indexOf(pid) > -1) return false;
        return onthouden ? onthouden.indexOf(pid) < 0 : !basisGelijst || !!basisGelijst[pid];
      });
  }

  /* Heet een eigen lijst nog zoals zijn idee, in een van de talen van de site? */
  function ideeNaam(lijst) {
    return !!lijst.concept && ['nl', 'de', 'fr', 'en'].some(function (taal) {
      var naam = TEKSTEN[taal] && TEKSTEN[taal]['c_' + lijst.concept];
      return !!naam && naam.toLowerCase() === lijst.naam.toLowerCase();
    });
  }

  function samenvoegenLijst(L, S, B) {
    var basisIds = B ? B.ids : [];
    var ids = [];
    L.ids.filter(function (pid) { return S.ids.indexOf(pid) < 0; }).concat(S.ids).forEach(function (pid) {
      if (ids.indexOf(pid) > -1) return;
      var inL = L.ids.indexOf(pid) > -1, inS = S.ids.indexOf(pid) > -1, inB = basisIds.indexOf(pid) > -1;
      if (inL === inB ? inS : inL) ids.push(pid);
    });
    var lijst = { id: L.id, naam: B && L.naam === B.naam ? S.naam : L.naam, ids: ids.slice(0, EIGEN_PER_LIJST) };
    if (L.concept || S.concept) lijst.concept = L.concept || S.concept;
    return lijst;
  }

  /* Wat het account van de eigen lijsten kent: alleen geuren die in een lijst van hierboven staan (zoals de relay). */
  function eigenVoorAccount(eigen, lijsten) {
    var gelijst = perGeur(lijsten);
    return eigen.map(function (lijst) {
      var kopie = { id: lijst.id, naam: lijst.naam, ids: gelijsteIds(lijst, gelijst) };
      if (lijst.concept) kopie.concept = lijst.concept;
      return kopie;
    });
  }

  /* Per eigen lijst de geuren die de lijst hier alleen nog onthoudt (geen favoriet meer, zie gelijsteIds); het account
   * kent ze niet. Na een samenvoeging zijn er geen (die snoeit), na een geslaagde POST wel (zie hierAangevuld). */
  function alleenOnthouden(eigen, lijsten) {
    var gelijst = perGeur(lijsten);
    var uit = {};
    eigen.forEach(function (lijst) {
      var weg = lijst.ids.filter(function (pid) { return !gelijst[pid]; });
      if (weg.length) uit[lijst.id] = weg;
    });
    return uit;
  }

  /* Twee { sleutel: waarde } gelijk (notities, of lijsten per geur). */
  function gelijkeMap(a, b) {
    var ka = Object.keys(a);
    return ka.length === Object.keys(b).length && ka.every(function (id) { return a[id] === b[id]; });
  }

  /*
   * De stand als losse sleutels: per geur zijn lijst (l:) en notitie (n:), per eigen lijst dat hij er is (e:), zijn naam
   * (m:), zijn idee (c:) en elke geur erin (i:lijst:geur). Wat er naar het account gaat, wordt zo met de basis vergeleken
   * (de volgorde telt niet: anders POSTte elke pagina zijn eigen volgorde, review 5 nov), en zo onthoudt de basis wat er
   * verstuurd is zolang het antwoord niet binnen is (onderweg, zie stuur en verwerk).
   */
  function plat(lijstenPerGeur, notities, eigen) {
    var uit = {};
    Object.keys(lijstenPerGeur).forEach(function (id) { uit['l:' + id] = lijstenPerGeur[id]; });
    Object.keys(notities).forEach(function (id) { uit['n:' + id] = notities[id]; });
    eigen.forEach(function (lijst) {
      uit['e:' + lijst.id] = 1;
      uit['m:' + lijst.id] = lijst.naam;
      if (lijst.concept) uit['c:' + lijst.id] = lijst.concept;
      lijst.ids.forEach(function (pid) { uit['i:' + lijst.id + ':' + pid] = 1; });
    });
    return uit;
  }

  /* Wat a anders heeft dan b (null = staat niet in a). */
  function verschil(a, b) {
    var uit = {};
    Object.keys(a).forEach(function (k) { if (a[k] !== b[k]) uit[k] = a[k]; });
    Object.keys(b).forEach(function (k) { if (a[k] === undefined) uit[k] = null; });
    return uit;
  }

  function uitPlat(p) {
    var lijsten = {};
    var notities = {};
    var eigen = {};
    var volgorde = [];
    Object.keys(p).forEach(function (k) {
      var rest = k.slice(2);
      if (k.indexOf('l:') === 0) lijsten[rest] = p[k];
      else if (k.indexOf('n:') === 0) notities[rest] = p[k];
      else if (k.indexOf('e:') === 0) {
        eigen[rest] = { id: rest, naam: p['m:' + rest] || '', ids: [] };
        volgorde.push(rest);
      }
    });
    Object.keys(p).forEach(function (k) {
      var delen = k.split(':');
      if (delen[0] === 'i' && eigen[delen[1]]) eigen[delen[1]].ids.push(delen[2]);
      if (delen[0] === 'c' && eigen[delen[1]]) eigen[delen[1]].concept = p[k];
    });
    return { lijsten: lijsten, notities: notities, eigen: volgorde.map(function (id) { return eigen[id]; }) };
  }

  /*
   * Verstuurd zonder dat het antwoord terugkwam (verbinding weg, of de pagina sloot): het account kan het wel hebben.
   * De relay zegt welke POSTs hij opsloeg (toegepast: de nummers van de laatste 500). Staat er een van deze browser bij,
   * dan had het account daarna precies wat hier verstuurd werd, en dat is de basis: wat een ander apparaat daarna
   * veranderde, wint dan (review sync v2: anders kwam een daar weggehaald hartje, een verwijderde lijst of een oudere
   * notitie terug). Staat hij er niet bij terwijl toegepast ver genoeg teruggaat, dan is hij niet opgeslagen.
   * Alleen als dat niet vast te stellen is (een relay zonder toegepast, of meer dan 500 opslagen sindsdien): heeft het
   * account nu precies wat hier verstuurd werd, dan telt dat als bekend in de basis. Anders zag de volgende
   * samenvoeging de eigen wijziging aan voor een wijziging van elders, en ging wat hier daarna werd teruggedraaid
   * (een lijst weer weg, een hartje weer aan) verloren (review sync v2, 5 nov). Het verandert alleen iets als deze
   * browser zijn eigen wijziging terugdraaide; dan wint dat, zoals elke wijziging hier. De zojuist geweigerde POST
   * (afgewezen) telt daarbij niet.
   * Eerste koppeling na het inloggen (vooraf, zie startKoppel): wat hier toen al in een lijst stond en in het account
   * in dezelfde lijst staat, telt als bekend. Zo blijft weg wat hier daarna werd weggehaald, ook als het account pas
   * later antwoordde; de rest gaat samen zoals de eerste keer altijd (review sync v2). Niet als er een POST van hier is
   * opgeslagen: dan is precies wat die verstuurde de basis.
   */
  function herzieBasis(basisPlat, serverPlat, beslist, data, afgewezen, vooraf) {
    var uit = Object.assign({}, basisPlat);
    var toegepast = Array.isArray(data.toegepast) ? data.toegepast : null;
    var opgeslagen = beslist.filter(function (stuk) { return toegepast && toegepast.indexOf(stuk.nr) > -1; });
    opgeslagen.forEach(function (stuk) {
      Object.keys(stuk.d).forEach(function (k) { if (stuk.d[k] === null) delete uit[k]; else uit[k] = stuk.d[k]; });
    });
    var verstuurd = opgeslagen.length ? [] : beslist.filter(function (stuk) {
      return stuk.nr !== afgewezen && !(toegepast && data.versie - stuk.v <= toegepast.length);
    });
    if (vooraf && !opgeslagen.length) {
      Object.keys(vooraf).forEach(function (id) { if (serverPlat['l:' + id] === vooraf[id]) uit['l:' + id] = vooraf[id]; });
    }
    verstuurd.forEach(function (stuk) {
      Object.keys(stuk.d).forEach(function (k) {
        var s = serverPlat[k] === undefined ? null : serverPlat[k];
        if (stuk.d[k] !== s || s === (basisPlat[k] === undefined ? null : basisPlat[k])) return;
        if (s === null) delete uit[k];
        else uit[k] = s;
      });
    });
    // een lijst die zo in de basis komt, heeft een naam nodig: die hier verstuurd werd, anders die van het account
    Object.keys(uit).forEach(function (k) {
      if (k.indexOf('e:') !== 0 || uit['m:' + k.slice(2)] !== undefined) return;
      var naam = serverPlat['m:' + k.slice(2)];
      verstuurd.forEach(function (stuk) { if (typeof stuk.d['m:' + k.slice(2)] === 'string') naam = stuk.d['m:' + k.slice(2)]; });
      uit['m:' + k.slice(2)] = naam;
    });
    return uit;
  }

  /* Alle notities gaan naar het account (versie 2), ook die bij een geur die je weghaalde: zo komt hij terug als de
   * geur terugkomt, ook op een ander apparaat of na het uitloggen. Hooguit NOTITIES_MAX, dan eerst die in een lijst. */
  function notitiesVoorAccount(notities, lijsten) {
    var gelijst = perGeur(lijsten);
    var ids = Object.keys(notities);
    var uit = {};
    ids.filter(function (id) { return gelijst[id]; }).concat(ids.filter(function (id) { return !gelijst[id]; }))
      .slice(0, NOTITIES_MAX).forEach(function (id) { uit[id] = notities[id]; });
    return uit;
  }

  function schrijfLokaal(lijsten, handles, notities, eigen) {
    LIJSTEN.forEach(function (k) { zet('sentir-' + k, lijsten[k]); });
    zet('sentir-handles', handles);
    if (notities) zet(NOTITIE_SLEUTEL, notities);
    if (eigen) zet(EIGEN_SLEUTEL, eigen);
    // De Lijst en de favorietenpagina lezen opnieuw in (geen 'sentir:lists-changed': dat zou weer naar het account gaan).
    try { window.dispatchEvent(new CustomEvent('sentir:lists-sync')); } catch (fout) {}
    try { window.dispatchEvent(new StorageEvent('storage', { key: 'sentir-fav' })); } catch (fout) {}
    tekenHartje();
  }

  /* Alleen wat de opslag accepteert (zie de relay): id's van cijfers, hooguit 500 per lijst, handles van de geuren in
   * de lijsten, hooguit 500 notities. Eén vreemde waarde mag niet de hele lijst tegenhouden. */
  function opgeschoond(lijsten, handles, notities, eigen) {
    var schoon = { fav: [], 'try': [], no: [] };
    var schoneHandles = {};
    LIJSTEN.forEach(function (k) {
      schoon[k] = (lijsten[k] || []).filter(function (id) { return /^\d{1,20}$/.test(id); }).slice(0, 500);
      schoon[k].forEach(function (id) {
        var h = handles && handles[id];
        if (typeof h === 'string' && /^[a-z0-9-]{1,120}$/.test(h)) schoneHandles[id] = h;
      });
    });
    return {
      lijsten: schoon,
      handles: schoneHandles,
      notities: notitiesVoorAccount(schoneNotities(notities), schoon),
      eigenLijsten: eigenVoorAccount(schoneEigen(eigen), schoon),
    };
  }

  /* Een antwoord van het account telt alleen met drie echte lijsten; anders (oude relay, foutpagina, iets anders dan
   * de relay) synchroniseren we niet, in plaats van alles als 'leeg' te lezen (review 5 nov). */
  function geldigeLijsten(lijsten) {
    return !!lijsten && typeof lijsten === 'object' && LIJSTEN.every(function (k) { return Array.isArray(lijsten[k]); });
  }

  /* En met een versie (versie 2): een relay zonder versie kan een oude stand niet weigeren, daar sturen we niets heen. */
  function geldigAntwoord(data) {
    return !!data && geldigeLijsten(data.lijsten) && typeof data.versie === 'number' && data.versie >= 0 &&
      Math.floor(data.versie) === data.versie;
  }

  /* De basis, als die van deze klant is. Anders (ander account, of nog nooit gesynchroniseerd) eerst samenvoegen. */
  function basisVanKlant() {
    var basis = lees(BASIS_SLEUTEL, null);
    return basis && basis.klant && String(basis.klant) === String(klant) ? basis : null;
  }

  function versieVan(basis) {
    return basis && typeof basis.versie === 'number' ? basis.versie : 0; // basis van vóór versie 2: 0
  }

  /* Ouder dan wat deze browser al weet: een ander tabblad sloeg intussen iets op (review 5 nov). */
  function ouderDanBasis(data) {
    var basis = basisVanKlant();
    return !!basis && data.versie < versieVan(basis);
  }

  /*
   * Een stand van het account (een GET, of de huidige stand bij een 409) samenvoegen met deze browser. De samenvoeging
   * komt hier te staan, de basis wordt wat het account nu heeft; wat dan nog anders is, verstuurt stuur().
   * Eerst de basis lezen, dan de lijsten, en eerst de lijsten schrijven, dan de basis: leest een ander tabblad er net
   * tussendoor, dan ziet het hooguit nieuwe lijsten bij een oude basis, en die POST weigert de relay.
   */
  function verwerk(data, afgewezen) {
    var vorige = lees(BASIS_SLEUTEL, null);
    var server = data.lijsten;
    var lokaal = leesLijsten();
    var anderAccount = !!(vorige && vorige.klant && String(vorige.klant) !== String(klant));
    // Geen basis meer (elders uitgelogd) of die van een andere klant (die logde hier intussen in): een antwoord dat te
    // laat binnenkwam in een tabblad van de vorige klant. Niets overnemen; anders wiste de volgende pagina van de nieuwe
    // klant zijn eigen wijzigingen (zie opruimenNaUitloggen; review sync v2).
    if (!vorige || anderAccount) return;
    var basis = (vorige && vorige.lijsten) || {};
    var basisNotities = schoneNotities(vorige && vorige.notities);
    var basisEigen = schoneEigen(vorige && vorige.eigenLijsten);
    // Stuurt het account geen notities of eigen lijsten mee, dan dat deel niet samenvoegen: de basis als 'server'
    // houdt alles hier zoals het is, in plaats van het als leeg te lezen.
    var serverNotities = data.notities === undefined ? basisNotities : schoneNotities(data.notities);
    var serverEigen = data.eigenLijsten === undefined ? basisEigen : schoneEigen(data.eigenLijsten);
    // Onderweg (zie stuur): wat met een oudere versie verstuurd werd, is nu beslist (de relay neemt het nooit meer aan);
    // wat met deze versie verstuurd werd, kan nog binnenkomen en blijft onthouden. vooraf: zie herzieBasis.
    var onderweg = Array.isArray(vorige.onderweg) ? vorige.onderweg : [];
    var beslist = onderweg.filter(function (stuk) { return stuk && stuk.d && stuk.v < data.versie; });
    var vooraf = vorige.vooraf && typeof vorige.vooraf === 'object' ? vorige.vooraf : null;
    if (beslist.length || vooraf) {
      var herzien = uitPlat(herzieBasis(plat(basis, basisNotities, basisEigen), plat(perGeur(server), serverNotities, serverEigen),
        beslist, data, afgewezen, vooraf));
      basis = herzien.lijsten;
      basisNotities = herzien.notities;
      basisEigen = herzien.eigen;
    }
    var nieuw = samenvoegen(lokaal, server, basis, anderAccount);
    var handles = Object.assign({}, data.handles || {}, lees('sentir-handles', {}) || {});
    var lokaleNotities = leesNotities();
    // Eerste koppeling na het inloggen: een notitie die hier alleen bewaard bleef (de geur stond bij het inloggen in
    // geen lijst en nu nog steeds niet, dus er is sindsdien niet in getypt) is geen wijziging van hier. Heeft het
    // account bij die geur een notitie, dan wint die (review sync v2, ronde 2: anders verving een maanden oude notitie
    // de nieuwere van een ander apparaat).
    if (vooraf) {
      var hierGelijst = perGeur(lokaal);
      Object.keys(lokaleNotities).forEach(function (id) {
        if (!vooraf[id] && !hierGelijst[id] && serverNotities[id] !== undefined && basisNotities[id] === undefined) {
          basisNotities[id] = lokaleNotities[id];
        }
      });
    }
    var notities = samenvoegenNotities(lokaleNotities, serverNotities, basisNotities, anderAccount, basis, perGeur(lokaal));
    // vergelijken zoals het account ze kent; geuren die hier geen favoriet meer zijn vallen bij deze koppeling af
    var lokaleEigen = eigenVoorAccount(leesEigen(), lokaal);
    // onthouden: zie hierAangevuld. Niet als een POST van hier de basis kan hebben bijgesteld (herzieBasis): opgeslagen,
    // of niet vast te stellen. De zojuist geweigerde POST en wat zeker niet is opgeslagen, tellen niet.
    var toegepast = Array.isArray(data.toegepast) ? data.toegepast : null;
    var bijgesteld = beslist.some(function (stuk) {
      return stuk.nr !== afgewezen && !(toegepast && toegepast.indexOf(stuk.nr) < 0 && data.versie - stuk.v <= toegepast.length);
    });
    var onthouden = !bijgesteld && vorige.onthouden && typeof vorige.onthouden === 'object' ? vorige.onthouden : null;
    var eigen = samenvoegenEigen(lokaleEigen, serverEigen, basisEigen, anderAccount, perGeur(nieuw), basis, onthouden);
    var eigenVeranderd = JSON.stringify(eigen) !== JSON.stringify(leesEigen());
    if (!gelijk(nieuw, lokaal) || !gelijkeMap(notities, lokaleNotities) || eigenVeranderd) {
      schrijfLokaal(nieuw, handles, notities, eigen);
    }
    zet(BASIS_SLEUTEL, {
      klant: klant, versie: data.versie, lijsten: perGeur(server), notities: serverNotities, eigenLijsten: serverEigen,
      onderweg: onderweg.filter(function (stuk) { return stuk && stuk.v === data.versie; }),
      onthouden: {}, // na het samenvoegen houden de eigen lijsten hier alleen favorieten
    });
  }

  /*
   * De stand van deze browser naar het account, met de versie van de basis. Niets als die inhoud al in de basis staat,
   * of als de basis niet van deze klant is (dan eerst koppel). 200: de basis wordt wat de relay opsloeg. 409: het
   * account was verder; samenvoegen met de stand die meekomt en opnieuw, hooguit 3 rondes, daarna pas bij de volgende
   * aanleiding. Mislukt het, dan blijft de oude basis staan en stuurt een volgende keer het verschil alsnog.
   * blijvend: ook als de pagina sluit (keepalive; klein genoeg, een realistische lijst is ~8 kB). Komt het antwoord
   * niet meer aan, dan blijft de wijziging hier staan tot de volgende koppeling.
   * Niets zolang deze browser voor deze klant nog nooit een geldig antwoord kreeg (de markering van het inloggen) en
   * het account niet te bereiken is (zie markeerMislukt): dan blijft alles hier tot de eerste geslaagde koppeling, in
   * plaats van de volledige stand met de notities steeds opnieuw te versturen (review sync v2, ronde 2).
   */
  function stuur(blijvend, ronde) {
    var basis = basisVanKlant(); // eerst de basis, dan de lijsten (zie verwerk)
    if (!basis || !window.fetch || (basis.vooraf && basis.mislukt >= 3)) return Promise.resolve();
    var eigenHier = leesEigen();
    var schoon = opgeschoond(leesLijsten(), lees('sentir-handles', {}) || {}, leesNotities(), eigenHier);
    var versie = versieVan(basis);
    var onderweg = Array.isArray(basis.onderweg) ? basis.onderweg : [];
    var d = verschil(plat(perGeur(schoon.lijsten), schoon.notities, schoon.eigenLijsten),
      plat(basis.lijsten || {}, schoneNotities(basis.notities), schoneEigen(basis.eigenLijsten)));
    // Zelfde inhoud als de basis en niets onderweg: niets te versturen. Wel iets onderweg: toch, dan beslist de relay.
    if (!Object.keys(d).length && !onderweg.length) return Promise.resolve();
    // Onthouden wat er verstuurd wordt (zie herzieBasis). Precies hetzelfde nog eens (bij het sluiten eerst
    // visibilitychange, dan pagehide; of steeds opnieuw zonder verbinding) gaat met hetzelfde nummer, en zonder
    // verschil hoeft er niets bij: zo verdringt dat geen eerder stuk (hooguit 20; review sync v2).
    var stuk = Object.keys(d).length ? onderweg.filter(function (oud) {
      return oud && oud.v === versie && JSON.stringify(oud.d) === JSON.stringify(d);
    })[0] : null;
    var nr = stuk ? stuk.nr : Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    if (Object.keys(d).length && !stuk) {
      // Het eerste stuk blijft altijd: meestal de POST van vlak voor een storing, en juist die kan opgeslagen zijn; wat
      // daarna zonder verbinding ging niet (review sync v2, ronde 2: na 20 offline wijzigingen viel hij er anders uit).
      var alle = onderweg.concat({ nr: nr, v: versie, d: d });
      basis.onderweg = alle.length > 20 ? alle.slice(0, 1).concat(alle.slice(-19)) : alle;
      zet(BASIS_SLEUTEL, basis);
    }
    return fetch(KOPPEL_URL, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: !!blijvend,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ lijsten: schoon.lijsten, handles: schoon.handles, notities: schoon.notities, eigenLijsten: schoon.eigenLijsten, versie: versie, nr: nr }),
    })
      .then(function (antwoord) {
        if (antwoord.status !== 200 && antwoord.status !== 409) return;
        return antwoord.json().then(function (data) {
          if (!geldigAntwoord(data)) return;
          laatsteSync = Date.now();
          relayFout = false;
          var ouder = ouderDanBasis(data); // dan weet deze browser al iets nieuwers: niet terugzetten
          if (antwoord.status === 200) {
            if (ouder) return;
            var nu = basisVanKlant();
            if (!nu) return; // intussen uitgelogd of een andere klant: niets terugzetten (zie verwerk)
            // Alleen als de basis nog die is waarop deze POST gebaseerd was: het eigen stuk staat nog onderweg (zonder
            // stuk: dezelfde versie, en geen markering van het inloggen). Na uitloggen en weer inloggen is deze browser
            // gewist en staat er een markering; met deze oude stand als basis leek dan alles hier weggehaald, en ging
            // een leeg account naar alle apparaten (review sync v2, ronde 2). De volgende GET of 409 herkent deze POST
            // via toegepast.
            var nuOnderweg = Array.isArray(nu.onderweg) ? nu.onderweg : [];
            if (Object.keys(d).length ? !nuOnderweg.some(function (stuk) { return stuk && stuk.nr === nr; })
              : versieVan(nu) !== versie || nu.vooraf) return;
            zet(BASIS_SLEUTEL, {
              klant: klant, versie: data.versie, lijsten: perGeur(data.lijsten), notities: schoneNotities(data.notities),
              eigenLijsten: schoneEigen(data.eigenLijsten),
              onderweg: nuOnderweg.filter(function (stuk) { return stuk && stuk.v === data.versie; }),
              onthouden: alleenOnthouden(eigenHier, schoon.lijsten),
            });
            return;
          }
          if (!ouder) verwerk(data, nr);
          if (ronde < 3) return stuur(blijvend, ronde + 1);
        });
      })
      .catch(function () {});
  }

  function begin() {
    bezig = Date.now();
    return ++beurt;
  }

  function klaar(mijn) {
    if (mijn !== beurt) return; // een nieuwer verzoek nam het over (dit hing langer dan HANGT)
    bezig = 0;
    var volgende = nogEens;
    nogEens = '';
    if (volgende === 'koppel') koppel();
    else if (volgende === 'zend') zend();
  }

  function loopt() {
    return !!bezig && Date.now() - bezig < HANGT;
  }

  function zend() {
    window.clearTimeout(zendTimer);
    zendTimer = 0;
    if (!klant || !window.fetch) return;
    if (loopt()) {
      if (!nogEens) nogEens = 'zend';
      return;
    }
    if (!basisVanKlant()) {
      koppel();
      return;
    }
    var mijn = begin();
    stuur(false, 1).then(function () { klaar(mijn); });
  }

  function zendStraks() {
    window.clearTimeout(zendTimer);
    zendTimer = window.setTimeout(zend, lijstNetWeg() ? 7000 : 1500);
  }

  /* Hier een eigen lijst verwijderd die het account nog heeft: dan wacht het versturen tot 'Ongedaan maken' weg is (6 s,
   * zie melding). Anders zette ongedaan maken na het versturen de lijst terug zonder wat een ander apparaat er intussen
   * in zette (review sync v2, ronde 2). De pagina verlaten of verbergen stuurt wel meteen (startFlush). */
  function lijstNetWeg() {
    var basis = basisVanKlant();
    if (!basis || !Array.isArray(basis.eigenLijsten)) return false;
    var hier = {};
    leesEigen().forEach(function (lijst) { hier[lijst.id] = 1; });
    return basis.eigenLijsten.some(function (lijst) { return lijst && !hier[lijst.id]; });
  }

  window.addEventListener('sentir:lists-changed', function () {
    tekenHartje();
    zendStraks();
  });

  window.addEventListener('sentir:notes-changed', zendStraks);
  window.addEventListener('sentir:favlijsten-changed', zendStraks);

  window.addEventListener('storage', function (event) {
    if (!event || !event.key || event.key.indexOf('sentir-') === 0) tekenHartje();
    // Een ander tabblad veranderde de lijsten (bijv. het hartje op een productpagina). De Lijst houdt zijn hartjes in
    // het geheugen en schreef bij de volgende klik zijn oude stand terug; zo leest hij eerst opnieuw in (review 5 nov).
    // Alleen echte storage-events (isTrusted): die komen altijd uit een ander tabblad.
    if (event && event.isTrusted && /^sentir-(fav|try|no)$/.test(event.key || '')) {
      try { window.dispatchEvent(new CustomEvent('sentir:lists-sync')); } catch (fout) {}
    }
  });

  // Terug uit de bfcache (ook zonder account): wat een andere pagina intussen opsloeg, komt daar niet in elke browser
  // als storage-event binnen. Eerst opnieuw laten inlezen; anders schreef de Lijst bij de volgende tik zijn oude
  // hartjes terug en verdween bijv. het hartje van de productpagina (review sync v2, ronde 2).
  window.addEventListener('pageshow', function (event) {
    if (!event || !event.persisted) return;
    tekenHartje();
    try { window.dispatchEvent(new CustomEvent('sentir:lists-sync')); } catch (fout) {}
  });

  /*
   * Uitgelogd na een sessie met account op dit apparaat (review 5 nov, privacy): de favorieten, notities en eigen
   * lijsten staan in dat account en komen terug bij het inloggen. Hier weghalen, zodat de volgende gebruiker van dit
   * apparaat ze niet ziet; de notities zijn privé ('Alleen jij ziet deze notitie').
   * Ook als hier nu een andere klant is ingelogd zonder dat er een uitgelogde pagina tussen zat (review sync v2, bijv.
   * een activeringslink): elke uitgelogde pagina wist, dus wat hier staat is van de vorige klant en hoort niet in dit
   * account.
   */
  function opruimenNaUitloggen() {
    var vorige = lees(BASIS_SLEUTEL, null);
    if (!vorige || !vorige.klant || String(vorige.klant) === String(klant)) return;
    // Ook de caches met product-id's (handles, namen, 'gemeld'): die verraden op een gedeelde computer wat de vorige
    // klant bewaarde, en 'gemeld' onderdrukte een dag lang de Klaviyo-melding van de volgende klant (review ronde 3).
    // Na het inloggen vult de eerste koppeling de handles weer uit het account en worden de namen opnieuw opgehaald.
    ['sentir-fav', 'sentir-try', 'sentir-no', NOTITIE_SLEUTEL, EIGEN_SLEUTEL, LAATSTE_SLEUTEL, BASIS_SLEUTEL,
      'sentir-handles', 'sentir-fav-namen', 'sentir-fav-gemeld'].forEach(function (sleutel) {
      try { window.localStorage.removeItem(sleutel); } catch (fout) {}
    });
    // De Lijst las de hartjes al tijdens het opbouwen van de pagina en schreef ze bij de eerste tik terug, ook in het
    // account van wie daarna inlogt (review sync v2, ronde 2): laat de pagina opnieuw inlezen.
    try { window.dispatchEvent(new CustomEvent('sentir:lists-sync')); } catch (fout) {}
  }

  /* Ophalen, samenvoegen en wat dan nog anders is versturen. */
  function koppel() {
    if (!klant || !window.fetch) return;
    window.clearTimeout(koppelTimer);
    koppelTimer = 0;
    if (loopt()) {
      nogEens = 'koppel';
      return;
    }
    var mijn = begin();
    var geenRelay = false; // 404, geen JSON of geen relay-antwoord: de app-proxy is er (nog) niet
    var ontvangen = false;
    laatstePoging = Date.now();
    fetch(KOPPEL_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (antwoord) {
        geenRelay = antwoord.status === 404;
        if (!antwoord.ok) throw new Error('geen account-opslag (' + antwoord.status + ')');
        geenRelay = true; // tot blijkt dat het de relay is (een foutpagina is geen JSON)
        return antwoord.json();
      })
      .then(function (data) {
        if (!geldigAntwoord(data)) throw new Error('onbekend antwoord van de account-opslag');
        geenRelay = false;
        ontvangen = true;
        relayFout = false;
        pogingen = 0;
        laatsteSync = Date.now();
        // Ouder dan wat een ander tabblad intussen opsloeg (review 5 nov): weggooien en opnieuw vragen, hooguit 3 keer.
        // Blijft hij lager (de rij is gewist, bijvoorbeeld op verzoek van de klant), dan geldt wat het account zegt.
        if (ouderDanBasis(data) && herhaald < 3) {
          herhaald++;
          nogEens = 'koppel';
          return;
        }
        herhaald = 0;
        verwerk(data);
        meldKoppelKlaar(true);
        return stuur(false, 1);
      })
      .catch(function () {
        if (!ontvangen) {
          relayFout = true;
          markeerMislukt(geenRelay);
        }
        // Geen relay achter het adres (nog niet uitgerold): niet steeds opnieuw vragen, de volgende pagina probeert het
        // weer (review sync v2, ronde 2: elke poging haalde de hele 404-pagina op).
        if (geenRelay) {
          meldKoppelKlaar(false);
          return;
        }
        // Geen verbinding of een storing: opnieuw na 2, 4, 8 en 16 s, daarna pas bij de volgende aanleiding.
        // Wijzigingen gaan intussen gewoon mee met zend() (met de versie van de basis).
        if (pogingen < 4) {
          pogingen++;
          koppelTimer = window.setTimeout(koppel, 1000 * Math.pow(2, pogingen));
        } else if (!ontvangen) {
          meldKoppelKlaar(false);
        }
      })
      .then(function () { klaar(mijn); });
  }

  function opnieuwKoppelen() {
    pogingen = 0;
    koppel();
  }

  /* Het account is gelezen (ok) of voorlopig niet te bereiken. Het dashboard (assets/sentir-dashboard.js, account-3)
   * toont tot dit signaal laadkaarten in plaats van 'Nog geen favorieten': na het inloggen staan de favorieten eerst
   * alleen in het account. Wat veranderde, meldt verwerk() al met 'sentir:lists-sync'. */
  function meldKoppelKlaar(ok) {
    try { window.dispatchEvent(new CustomEvent('sentir:koppel-klaar', { detail: { ok: ok } })); } catch (fout) {}
  }

  /*
   * Een mislukte GET op de markering van het inloggen (deze browser kreeg voor deze klant nog nooit een geldig
   * antwoord). Na 3 keer achter elkaar, of meteen als er geen relay achter het adres zit (404 of geen relay-antwoord:
   * nog niet uitgerold), verstuurt stuur() niets meer tot de eerste geslaagde koppeling (review sync v2, ronde 2). Eén
   * hapering laat de POST vanaf de markering nog door: zijn 409 dient dan als eerste koppeling.
   */
  function markeerMislukt(geenRelay) {
    var basis = basisVanKlant();
    if (!basis || !basis.vooraf) return;
    basis.mislukt = Math.max(geenRelay ? 3 : 0, (Number(basis.mislukt) || 0) + 1);
    zet(BASIS_SLEUTEL, basis);
  }

  /* Bij het laden. Een ingelogde pagina zonder basis markeert deze browser meteen (review 5 nov): dan wist uitloggen
   * alles, ook als het account nooit antwoordde (gedeelde computer). Een lege basis voegt samen zoals geen basis.
   * vooraf: wat hier bij het inloggen in de lijsten stond (zie herzieBasis). */
  function startKoppel() {
    if (!klant) return;
    if (!lees(BASIS_SLEUTEL, null)) {
      zet(BASIS_SLEUTEL, { klant: klant, versie: 0, lijsten: {}, notities: {}, eigenLijsten: [], vooraf: perGeur(leesLijsten()) });
    }
    koppel();
  }

  /*
   * Na startNotities (review 5 nov): die bewaart bij het sluiten eerst de notitie waarin nog getypt wordt, en die gaat
   * hier dan mee. Ook bij naar de achtergrond gaan (app-wissel op de telefoon; daarna komt vaak geen pagehide meer).
   * Alleen als er iets is dat het account nog niet heeft; dat kijkt stuur() na.
   * Terug naar een pagina die lang open stond (bfcache, of een tab van uren geleden): eerst opnieuw ophalen.
   */
  function startFlush() {
    if (!klant) return;
    // Niet als deze pagina het account nooit bereikte en haar laatste GET mislukte (relay er nog niet, of een storing):
    // dan ging bij elke paginawissel de volledige stand mee, ook de notities. Het blijft hier en gaat mee met de
    // volgende koppeling (review sync v2, ronde 2).
    var flush = function () { if (laatsteSync || !relayFout) stuur(true, 1); };
    window.addEventListener('pagehide', flush);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
      else if (document.visibilityState === 'visible' && Date.now() - Math.max(laatsteSync, laatstePoging) > VERS) opnieuwKoppelen();
    });
    // Opnieuw inlezen bij terugkeer doet de pageshow-luisteraar bij 'storage' hierboven (ook zonder account). Vlak na
    // een mislukte GET hier geen nieuwe reeks bij elke stap terug.
    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted && !(relayFout && Date.now() - laatstePoging < VERS)) opnieuwKoppelen();
    });
  }

  /* ---------------------------------------------- 4. notities (favorietenpagina) -- */

  /*
   * Op de favorietenpagina (sections/sentir-favorieten.liquid uit de bouwstraat, [data-favpage]) krijgt elke kaart
   * onderaan een notitie. Dicht is het een smalle balk: 'Notitie toevoegen', of de eerste twee regels van je notitie.
   * Open is het een tekstveld dat vanzelf bewaart tijdens het typen. De kaarten bouwt de pagina zelf op (en opnieuw na
   * een synchronisatie); een MutationObserver hangt de notitie eraan. Teksten uit de woordenlijst (TEKSTEN), in de taal van
   * het domein; de pagina zelf staat buiten Weglot.
   * De tekst van de klant komt alleen via textContent en value op de pagina, nooit als HTML.
   */
  var NOTITIE_TEKST = {
    toevoegen: t('notToevoegen'),
    open: t('notOpen'),
    voorbeeld: t('notVoorbeeld'),
    prive: t('notPrive'),
    bewaard: t('notBewaard'),
    klaar: t('notKlaar'),
    bij: t('notBij'),
  };
  var notitieNummer = 0;
  var notitieTimers = {};

  var PEN = '<svg class="scl-note-pen" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/></svg>';
  var PIJL = '<svg class="scl-note-pijl" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';

  function maakNotitie(kaart) {
    var id = kaart.getAttribute('data-card') || '';
    if (!/^\d{1,20}$/.test(id) || kaart.querySelector('[data-notitie]')) return;
    var kop = kaart.querySelector('h2, h3');
    var naam = (kop && kop.textContent.trim()) || kaart.getAttribute('data-title') || '';
    var nr = ++notitieNummer;
    var blok = document.createElement('div');
    blok.className = 'scl-note';
    blok.setAttribute('data-notitie', id);
    blok.innerHTML =
      '<button type="button" class="scl-note-kop" aria-expanded="false" aria-controls="scl-note-' + nr + '">' + PEN +
        '<span class="scl-note-tekst"><span class="visually-hidden" data-naam></span><span data-tekst></span></span>' + PIJL +
      '</button>' +
      '<div class="scl-note-veld" id="scl-note-' + nr + '" hidden>' +
        '<label class="visually-hidden" for="scl-note-veld-' + nr + '"></label>' +
        '<textarea id="scl-note-veld-' + nr + '" rows="3" maxlength="' + NOTITIE_MAX + '"></textarea>' +
        '<div class="scl-note-voet">' +
          '<span class="scl-note-status"></span>' +
          '<span class="visually-hidden" aria-live="polite" data-notitie-live></span>' +
          '<span class="scl-note-teller" aria-hidden="true"></span>' +
          '<button type="button" class="scl-note-klaar"></button>' +
        '</div>' +
      '</div>';
    blok.querySelector('[data-naam]').textContent = naam + ': ';
    blok.querySelector('label').textContent = NOTITIE_TEKST.bij + naam;
    blok.querySelector('textarea').placeholder = NOTITIE_TEKST.voorbeeld;
    blok.querySelector('.scl-note-status').textContent = NOTITIE_TEKST.prive;
    blok.querySelector('.scl-note-klaar').textContent = NOTITIE_TEKST.klaar;
    kaart.appendChild(blok);
    tekenNotitie(blok);
  }

  /* De balk bijwerken naar wat er bewaard is (niet het veld waarin iemand op dat moment typt). Een veld met de focus
   * waarin sinds het tonen niets getypt is, krijgt wel de nieuwe tekst (review sync v2: anders bewaarde het bij het
   * verlaten zijn oude tekst over een nieuwere van een ander apparaat of tabblad heen). */
  function tekenNotitie(blok) {
    var tekst = leesNotities()[blok.getAttribute('data-notitie')] || '';
    var open = blok.classList.contains('open');
    var veld = blok.querySelector('textarea');
    blok.classList.toggle('heeft-tekst', !!tekst && !open);
    blok.querySelector('[data-tekst]').textContent = open ? NOTITIE_TEKST.open : (tekst || NOTITIE_TEKST.toevoegen);
    if (document.activeElement === veld && getypt(veld)) return;
    if (veld.value.trim().slice(0, NOTITIE_MAX) !== tekst) veld.value = tekst;
    veld.sentirGetekend = tekst;
  }

  /* Staat er in het veld iets anders dan wat het toonde of bewaarde? */
  function getypt(veld) {
    return veld.sentirGetekend === undefined || veld.value.trim().slice(0, NOTITIE_MAX) !== veld.sentirGetekend;
  }

  function groei(veld) {
    veld.style.height = 'auto';
    veld.style.height = Math.min(veld.scrollHeight + 2, 240) + 'px';
  }

  function telNotitie(blok) {
    var lengte = blok.querySelector('textarea').value.length;
    blok.querySelector('.scl-note-teller').textContent = lengte >= NOTITIE_MAX - 100 ? lengte + '/' + NOTITIE_MAX : '';
  }

  function zetNotitieOpen(blok, open, focus) {
    var veld = blok.querySelector('textarea');
    blok.classList.toggle('open', open);
    blok.querySelector('.scl-note-kop').setAttribute('aria-expanded', String(open));
    blok.querySelector('.scl-note-veld').hidden = !open;
    tekenNotitie(blok);
    if (!open) return;
    groei(veld);
    telNotitie(blok);
    if (focus) {
      veld.focus();
      try { veld.setSelectionRange(veld.value.length, veld.value.length); } catch (fout) {}
    }
  }

  function bewaarNotitie(blok, stil) {
    var id = blok.getAttribute('data-notitie');
    window.clearTimeout(notitieTimers[id]);
    var veld = blok.querySelector('textarea');
    // Alleen wat hier getypt is: een veld dat sinds het tonen niet veranderde, zet geen oudere tekst terug (zie
    // tekenNotitie). Zo ook niet de notitie van een vorige klant in een tabblad dat nog openstond (review sync v2).
    if (!getypt(veld)) return;
    var tekst = veld.value.trim().slice(0, NOTITIE_MAX);
    veld.sentirGetekend = tekst;
    var notities = leesNotities();
    if ((notities[id] || '') === tekst) return;
    if (tekst) notities[id] = tekst;
    else delete notities[id];
    zet(NOTITIE_SLEUTEL, notities);
    try { window.dispatchEvent(new CustomEvent('sentir:notes-changed', { detail: { id: id } })); } catch (fout) {}
    if (stil) return;
    var status = blok.querySelector('.scl-note-status');
    status.textContent = NOTITIE_TEKST.bewaard;
    status.classList.add('is-bewaard');
    var live = blok.querySelector('[data-notitie-live]');
    if (live) live.textContent = NOTITIE_TEKST.bewaard;
    window.clearTimeout(notitieTimers['status-' + id]);
    notitieTimers['status-' + id] = window.setTimeout(function () {
      status.textContent = NOTITIE_TEKST.prive;
      status.classList.remove('is-bewaard');
      if (live) live.textContent = '';
    }, 1800);
  }

  function startNotities() {
    var pagina = document.querySelector('[data-favpage]');
    if (!pagina) return;
    var alleBlokken = function () { return Array.prototype.slice.call(pagina.querySelectorAll('[data-notitie]')); };
    var koppelKaarten = function () {
      Array.prototype.forEach.call(pagina.querySelectorAll('[data-favgrid] .pcard[data-card]'), maakNotitie);
    };
    koppelKaarten();
    if (window.MutationObserver) {
      var waarnemer = new MutationObserver(koppelKaarten);
      Array.prototype.forEach.call(pagina.querySelectorAll('[data-favgrid]'), function (raster) {
        waarnemer.observe(raster, { childList: true });
      });
    }

    pagina.addEventListener('click', function (event) {
      var kop = event.target.closest('.scl-note-kop');
      var klaar = event.target.closest('.scl-note-klaar');
      var blok = (kop || klaar) && (kop || klaar).closest('[data-notitie]');
      if (!blok) return;
      var open = !!kop && !blok.classList.contains('open');
      if (!open) bewaarNotitie(blok, true);
      zetNotitieOpen(blok, open, open);
      if (klaar) blok.querySelector('.scl-note-kop').focus();
    });

    pagina.addEventListener('input', function (event) {
      var veld = event.target.closest && event.target.closest('.scl-note textarea');
      if (!veld) return;
      var blok = veld.closest('[data-notitie]');
      groei(veld);
      telNotitie(blok);
      var id = blok.getAttribute('data-notitie');
      window.clearTimeout(notitieTimers[id]);
      notitieTimers[id] = window.setTimeout(function () { bewaarNotitie(blok); }, 600);
    });

    // Weg uit het veld (ook als de kaart verdwijnt of de pagina sluit): meteen bewaren.
    pagina.addEventListener('focusout', function (event) {
      var veld = event.target.closest && event.target.closest('.scl-note textarea');
      if (veld) bewaarNotitie(veld.closest('[data-notitie]'), true);
    });
    // Ook bij sluiten of naar de achtergrond gaan (app-wissel op de telefoon); deel 3 (startFlush, na deze luisteraars
    // geregistreerd) stuurt hem dan meteen mee naar het account.
    var bewaarOpen = function () {
      alleBlokken().forEach(function (blok) { if (blok.classList.contains('open')) bewaarNotitie(blok, true); });
    };
    window.addEventListener('pagehide', bewaarOpen);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') bewaarOpen(); });

    pagina.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var veld = event.target.closest && event.target.closest('.scl-note textarea');
      if (!veld) return;
      var blok = veld.closest('[data-notitie]');
      bewaarNotitie(blok, true);
      zetNotitieOpen(blok, false);
      blok.querySelector('.scl-note-kop').focus();
    });

    // Na een synchronisatie met het account of een wijziging in een ander tabblad.
    window.addEventListener('sentir:lists-sync', function () { alleBlokken().forEach(tekenNotitie); });
    window.addEventListener('storage', function (event) {
      if (event && event.key === NOTITIE_SLEUTEL) alleBlokken().forEach(tekenNotitie);
    });
  }

  /* --------------------------------------------------------------- 5. Klaviyo -- */

  /*
   * Zelfde velden en aanroep als 'Added to Cart' in cart-drawer.js (Name, ProductID, URL, ImageURL, Price, $value),
   * zodat een flow-mail dezelfde blokken kan gebruiken. Wat er gemeld wordt volgt uit een vergelijking met de vorige
   * stand van de favorieten; dan maakt het niet uit welke knop het deed (Lijst, favorietenpagina, later de PDP).
   * Een samenvoeging met het account ('sentir:lists-sync') werkt alleen het profiel bij, zonder gebeurtenis.
   *
   * Klaviyo bewaart dit alleen voor bezoekers die het kent: via een klik uit een mail, een Klaviyo-formulier of een
   * ingelogd account. Meldt iemand zich later aan via een Klaviyo-formulier, dan gaan de favorieten alsnog naar dat
   * profiel (net als de uitslag van de geurquiz). Aan-uit-aan van hetzelfde hartje geeft hooguit één gebeurtenis per
   * dag (sentir-fav-gemeld), anders krijgt iemand die twijfelt meerdere opvolgmails.
   */
  var GEMELD_SLEUTEL = 'sentir-fav-gemeld';
  var NAMEN_SLEUTEL = 'sentir-fav-namen';
  var DAG = 24 * 60 * 60 * 1000;
  var klaviyoStand = null;
  var productCache = {};

  function klaviyo(soort, naam, lading) {
    try {
      if (window.klaviyo && typeof window.klaviyo[soort] === 'function') {
        if (soort === 'track') window.klaviyo.track(naam, lading);
        else window.klaviyo.identify(naam);
      } else if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(soort === 'track' ? ['track', naam, lading] : ['identify', naam]);
      }
    } catch (fout) { /* Meten mag de favorieten nooit in de weg zitten. */ }
  }

  /* De handle staat op de kaart (data-handle, live-laag) of in sentir-handles. data-url is op nl. door Weglot vertaald
   * (/producten/...) en dus geen bruikbare handle. */
  function handleVan(id) {
    var kaart = document.querySelector('.pcard[data-card="' + id + '"][data-handle]');
    return (kaart && kaart.getAttribute('data-handle')) || (lees('sentir-handles', {}) || {})[id] || '';
  }

  /* Productgegevens via /products/<handle>.js (één keer per pagina per geur). */
  function productVan(id) {
    if (productCache[id]) return productCache[id];
    var handle = handleVan(id);
    productCache[id] = !handle || !window.fetch
      ? Promise.resolve(null)
      : fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (antwoord) { return antwoord.ok ? antwoord.json() : null; })
        .catch(function () { return null; });
    return productCache[id];
  }

  function absoluut(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }

  function breedte(url, px) {
    if (!url || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
  }

  /* De namen van alle favorieten, voor het profiel. Bekende namen staan in sentir-fav-namen, de rest wordt opgehaald. */
  function favorietenProfiel() {
    var fav = leesLijsten().fav;
    var namen = lees(NAMEN_SLEUTEL, {}) || {};
    var handles = lees('sentir-handles', {}) || {};
    return Promise.all(fav.slice(0, 100).map(function (id) {
      if (namen[id]) return Promise.resolve(namen[id]);
      return productVan(id).then(function (p) {
        if (p && p.title) namen[id] = p.title;
        return namen[id] || handleVan(id) || id;
      });
    })).then(function (lijst) {
      zet(NAMEN_SLEUTEL, namen);
      // Eigen lijsten (deel 6): de namen, en apart wat er in 'Volgende bestelling' staat (voor een herinneringsflow).
      var eigen = leesEigen();
      var volgende = eigen.filter(function (l) { return l.concept === 'volgende-bestelling'; })[0];
      return {
        Favorieten: lijst.join(', '),
        Favorieten_lijst: lijst,
        Favorieten_handles: fav.slice(0, 100).map(function (id) { return handles[id] || handleVan(id); }).filter(Boolean),
        Favorieten_aantal: fav.length,
        Favorietenlijsten: eigen.map(function (l) { return l.naam; }),
        Volgende_bestelling: volgende ? gelijsteIds(volgende).map(function (id) { return namen[id] || handleVan(id) || id; }) : [],
      };
    });
  }

  function bronVanPagina() {
    if (document.querySelector('[data-favpage]')) return 'favorietenpagina';
    if (document.querySelector('.scl')) return 'collectie';
    return 'overig';
  }

  function meldToegevoegd(id, aantal) {
    var gemeld = lees(GEMELD_SLEUTEL, {}) || {};
    var nu = Date.now();
    Object.keys(gemeld).forEach(function (k) { if (nu - gemeld[k] > 7 * DAG) delete gemeld[k]; });
    if (gemeld[id] && nu - gemeld[id] < DAG) return;
    gemeld[id] = nu;
    zet(GEMELD_SLEUTEL, gemeld);
    var taal = window.location.hostname.split('.')[0];
    productVan(id).then(function (p) {
      var prijs = p ? (p.price || 0) / 100 : 0;
      klaviyo('track', 'Added to Favorites', {
        Name: (p && p.title) || '',
        Brand: (p && p.vendor) || 'Sentir Parfum',
        ProductID: Number(id),
        Handle: (p && p.handle) || handleVan(id),
        URL: absoluut(p && p.url),
        // 600 px breed is genoeg voor een mail; het CDN kiest zelf het formaat (WebP alleen als de lezer dat aankan)
        ImageURL: breedte(absoluut(p && (p.featured_image || (p.images && p.images[0]))), 600),
        Price: prijs,
        $value: prijs,
        Favorieten_aantal: aantal,
        Bron: bronVanPagina(),
        Taal: /^[a-z]{2}$/.test(taal) ? taal : 'en',
      });
    });
  }

  function profielBijwerken() {
    favorietenProfiel().then(function (profiel) { klaviyo('identify', profiel); });
  }

  function vergelijkMetKlaviyo(metGebeurtenis) {
    var fav = leesLijsten().fav;
    var nieuw = {};
    fav.forEach(function (id) { nieuw[id] = true; });
    if (!klaviyoStand) { klaviyoStand = nieuw; return; }
    var veranderd = fav.length !== Object.keys(klaviyoStand).length;
    fav.forEach(function (id) {
      if (klaviyoStand[id]) return;
      veranderd = true;
      if (metGebeurtenis) meldToegevoegd(id, fav.length);
    });
    klaviyoStand = nieuw;
    if (veranderd) profielBijwerken();
  }

  function startKlaviyo() {
    vergelijkMetKlaviyo(false);
    window.addEventListener('sentir:lists-changed', function () { vergelijkMetKlaviyo(true); });
    window.addEventListener('sentir:lists-sync', function () { vergelijkMetKlaviyo(false); });
    var lijstTimer = 0;
    window.addEventListener('sentir:favlijsten-changed', function () {
      window.clearTimeout(lijstTimer);
      lijstTimer = window.setTimeout(profielBijwerken, 2000);
    });
    window.addEventListener('storage', function (event) {
      if (event && event.key === 'sentir-fav' && event.isTrusted) vergelijkMetKlaviyo(false);
    });
    // Eén keer per bezoek het profiel bijwerken: wie sinds de vorige keer bekend werd (klik uit een mail), krijgt zo
    // zijn favorieten alsnog op het profiel.
    try {
      if (leesLijsten().fav.length && !window.sessionStorage.getItem('sentir-fav-profiel')) {
        window.sessionStorage.setItem('sentir-fav-profiel', '1');
        window.setTimeout(profielBijwerken, 4000);
      }
    } catch (fout) {}
    // Aanmelden via een Klaviyo-formulier: nu is bekend wie het is, dus de favorieten naar dat profiel.
    window.addEventListener('klaviyoForms', function (event) {
      var d = (event && event.detail) || {};
      if (d.type !== 'submit' || !leesLijsten().fav.length) return;
      var adres = d.metaData && (d.metaData.$email || d.metaData.email);
      favorietenProfiel().then(function (profiel) {
        if (adres) profiel.$email = adres;
        klaviyo('identify', profiel);
      });
    });
  }

  /* ------------------------------------------------- 6. eigen lijsten (borden) -- */

  /*
   * Zoals borden op Pinterest (Thomas, 4 nov 2026). Een lijst is een deel van de favorieten: wie iets in een lijst zet,
   * zet er ook een hartje bij. Bij een nieuwe lijst staan ideeën klaar die met één tik een lijst maken.
   *  - Het venster 'Opslaan in een lijst' (openBlad) werkt op elke pagina: vanuit de melding na een hartje ('Lijst
   *    kiezen') en vanuit de knop op elke kaart van de favorietenpagina.
   *  - Op de favorietenpagina een rij lijsten met een collage van de geuren; een lijst kiezen toont alleen die geuren,
   *    met 'Alles in je winkelmand', 'Naam wijzigen' en 'Lijst verwijderen' (met ongedaan maken).
   * Teksten uit de woordenlijst (TEKSTEN) in de taal van het domein. Namen van klanten alleen via
   * textContent en value op de pagina.
   */
  var CONCEPTEN = [
    { concept: 'volgende-bestelling', naam: t('c_volgende-bestelling') },
    { concept: 'favoriete-set', naam: t('c_favoriete-set') },
    { concept: 'cadeau', naam: t('c_cadeau') },
    { concept: 'zomer', naam: t('c_zomer') },
    { concept: 'winter', naam: t('c_winter') },
    { concept: 'avond', naam: t('c_avond') },
    { concept: 'elke-dag', naam: t('c_elke-dag') },
    { concept: 'proberen', naam: t('c_proberen') },
  ];
  var ICOON = {
    kruis: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    vink: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    lijst: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 4h10a1 1 0 0 1 1 1v15l-6-3.6L6 20V5a1 1 0 0 1 1-1z"/></svg>',
  };

  /* Laatst gekozen lijst van de Pinterest-knoppen (4 nov 2026; op 5 nov weer uit, de melding volstaat): de sleutel
   * wordt alleen nog opgeruimd bij uitloggen. */
  var LAATSTE_SLEUTEL = 'sentir-favlijst-laatste';

  function lijstVan(id) {
    return leesEigen().filter(function (l) { return l.id === id; })[0] || null;
  }

  function isFavoriet(pid) {
    return perGeur(leesLijsten())[pid] === 'fav';
  }

  function staatIn(pid, doel) {
    if (!isFavoriet(pid)) return false;
    if (doel === 'fav') return true;
    var lijst = lijstVan(doel);
    return !!lijst && lijst.ids.indexOf(pid) > -1;
  }

  function telTekst(n) {
    return n === 1 ? t('geur1') : t('geurN', { n: n });
  }

  function nieuwLijstId() {
    return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  /* Bestaat er al een lijst met die naam (of dat idee), dan wordt het die. */
  function maakLijst(naam, concept, eerste) {
    naam = String(naam || '').trim().slice(0, EIGEN_NAAM_MAX);
    if (!naam) return null;
    var eigen = leesEigen();
    var bestaand = eigen.filter(function (l) {
      return l.naam.toLowerCase() === naam.toLowerCase() || (concept && l.concept === concept);
    })[0];
    if (!bestaand && eigen.length >= EIGEN_MAX) return null;
    var lijst = bestaand || { id: nieuwLijstId(), naam: naam, ids: [] };
    if (!bestaand) {
      if (concept) lijst.concept = concept;
      eigen.unshift(lijst);
    }
    if (eerste && lijst.ids.indexOf(eerste) < 0 && lijst.ids.length < EIGEN_PER_LIJST) lijst.ids.unshift(eerste);
    zetEigen(eigen);
    if (eerste) maakFavoriet(eerste);
    return lijst;
  }

  function zetInLijst(lijstId, pid, aan) {
    var eigen = leesEigen();
    var lijst = eigen.filter(function (l) { return l.id === lijstId; })[0];
    if (!lijst) return false;
    var plek = lijst.ids.indexOf(pid);
    if (aan && plek < 0) {
      if (lijst.ids.length >= EIGEN_PER_LIJST) return false;
      lijst.ids.unshift(pid);
    }
    if (!aan && plek > -1) lijst.ids.splice(plek, 1);
    zetEigen(eigen);
    if (aan) maakFavoriet(pid);
    return true;
  }

  function maakFavoriet(pid) {
    var lijsten = leesLijsten();
    if (perGeur(lijsten)[pid] === 'fav') return;
    LIJSTEN.forEach(function (k) { lijsten[k] = lijsten[k].filter(function (x) { return x !== pid; }); });
    lijsten.fav.push(pid);
    LIJSTEN.forEach(function (k) { zet('sentir-' + k, lijsten[k]); });
    var handle = handleVan(pid);
    if (handle) {
      var handles = lees('sentir-handles', {}) || {};
      handles[pid] = handle;
      zet('sentir-handles', handles);
    }
    meldLijstenVeranderd();
  }

  function verwijderFavoriet(pid) {
    var lijsten = leesLijsten();
    if (perGeur(lijsten)[pid] !== 'fav') return;
    lijsten.fav = lijsten.fav.filter(function (x) { return x !== pid; });
    zet('sentir-fav', lijsten.fav);
    meldLijstenVeranderd();
  }

  function meldLijstenVeranderd() {
    try { window.dispatchEvent(new CustomEvent('sentir:lists-changed')); } catch (fout) {}
    // de Lijst leest zijn hartjes opnieuw in (live-laag, MARKS_LIVE)
    try { window.dispatchEvent(new CustomEvent('sentir:lists-sync')); } catch (fout2) {}
  }

  /*
   * Eén favoriet aan of uit vanuit een andere plek (accessoireslider, chatkaarten, productpagina), met de melding in de
   * taal van het domein. opties: { handle, naam, opener } (opener = de knop, voor de focus na het venster).
   */
  function zetFavoriet(pid, aan, opties) {
    pid = String(pid || '');
    if (!/^\d{1,20}$/.test(pid)) return false;
    opties = opties || {};
    if (opties.handle && /^[a-z0-9-]{1,120}$/.test(opties.handle)) {
      var handles = lees('sentir-handles', {}) || {};
      handles[pid] = opties.handle;
      zet('sentir-handles', handles);
    }
    var naam = (opties.naam || '').trim() || t('dezeGeur');
    if (!aan) {
      verwijderFavoriet(pid);
      melding(t('uitFav', { naam: naam }));
      return true;
    }
    maakFavoriet(pid);
    var acties = [{ label: t('voegToe'), doe: function () { openBlad(pid, opties.opener || null); } }];
    if (!document.querySelector('[data-favpage]')) acties.push({ label: t('mijnFav'), href: favorietenUrl() });
    var tip = !klant && !accountTipGetoond;
    if (tip) accountTipGetoond = true;
    melding(t('inFav', { naam: naam }), { acties: acties, accountTip: tip });
    return true;
  }

  window.SentirFavorieten = {
    isFavoriet: function (pid) { return isFavoriet(String(pid || '')); },
    zet: zetFavoriet,
  };

  function beeldVan(pid) {
    var img = document.querySelector('.pcard[data-card="' + pid + '"] .pcard-img img');
    if (img && (img.currentSrc || img.src)) return Promise.resolve(img.currentSrc || img.src);
    return productVan(pid).then(function (p) {
      return p ? breedte(absoluut(p.featured_image || (p.images && p.images[0])), 240) : '';
    });
  }

  function naamVan(pid) {
    var kaart = document.querySelector('.pcard[data-card="' + pid + '"]');
    var kop = kaart && kaart.querySelector('h2, h3');
    if (kop && kop.textContent.trim()) return Promise.resolve(kop.textContent.trim());
    return productVan(pid).then(function (p) { return (p && p.title) || ''; });
  }

  /* Collage: één groot beeld en twee kleine, zoals een bord op Pinterest. */
  function vulCover(el, ids, aantal) {
    el.textContent = '';
    el.classList.toggle('is-leeg', !ids.length);
    el.setAttribute('data-aantal', String(Math.min(ids.length, aantal)));
    if (!ids.length) el.innerHTML = ICOON.lijst;
    ids.slice(0, aantal).forEach(function (pid) {
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      el.appendChild(img);
      beeldVan(pid).then(function (src) {
        if (src) img.src = src;
        else if (img.parentNode) img.parentNode.removeChild(img);
      });
    });
  }

  /* -- het venster -- */
  var blad = null;
  var bladOpener = null;
  var bladProduct = '';
  var bladVoor = '';
  var bladSluitTimer = 0;

  function bouwBlad() {
    blad = document.createElement('div');
    blad.className = 'sentir-blad wg-notranslate';
    blad.setAttribute('translate', 'no');
    blad.setAttribute('data-wg-notranslate', '');
    blad.hidden = true;
    blad.innerHTML =
      '<div class="sentir-blad__achter" data-blad-dicht></div>' +
      '<div class="sentir-blad__paneel" role="dialog" aria-modal="true" aria-labelledby="sentir-blad-titel">' +
        '<div class="sentir-blad__kop">' +
          '<h2 class="sentir-blad__titel" id="sentir-blad-titel"></h2>' +
          '<button type="button" class="sentir-blad__sluit" data-blad-dicht aria-label="' + t('sluiten') + '">' + ICOON.kruis + '</button>' +
        '</div>' +
        '<div class="sentir-blad__product" data-blad-product><img alt="" data-blad-beeld><span data-blad-naam></span></div>' +
        '<div class="sentir-blad__deel" data-blad-bestaand>' +
          '<p class="sentir-blad__label">' + t('jeLijsten') + '</p>' +
          '<ul class="sentir-blad__rijen" role="list" data-blad-rijen></ul>' +
        '</div>' +
        // Eerst de ideeën (één tik = een lijst), dan pas een eigen naam: op de telefoon schuift het toetsenbord anders
        // over de ideeën heen.
        '<div class="sentir-blad__deel">' +
          '<p class="sentir-blad__label" data-blad-nieuwlabel>' + t('nieuweLijst') + '</p>' +
          '<p class="sentir-blad__sublabel" data-blad-ideelabel>' + t('kiesIdee') + '</p>' +
          '<div class="sentir-blad__ideeen" data-blad-ideeen></div>' +
          '<p class="sentir-blad__sublabel" data-blad-eigenlabel>' + t('ofEigenNaam') + '</p>' +
          '<form class="sentir-blad__nieuw" data-blad-form>' +
            '<label class="visually-hidden" for="sentir-blad-naam">' + t('naamNieuweLijst') + '</label>' +
            '<input id="sentir-blad-naam" type="text" maxlength="' + EIGEN_NAAM_MAX + '" autocomplete="off" enterkeyhint="done" placeholder="' + t('voorbeeldNaam') + '">' +
            '<button type="submit">' + t('maakLijst') + '</button>' +
          '</form>' +
        '</div>' +
        '<p class="visually-hidden" aria-live="polite" data-blad-live></p>' +
      '</div>';
    document.body.appendChild(blad);

    blad.addEventListener('click', function (event) {
      if (event.target.closest('[data-blad-dicht]')) { sluitBlad(); return; }
      var rij = event.target.closest('.sentir-blad__rij');
      if (rij) {
        var aan = rij.getAttribute('aria-pressed') !== 'true';
        var lijstId = rij.getAttribute('data-lijst');
        if (!zetInLijst(lijstId, bladProduct, aan)) {
          var vol = lijstVan(lijstId);
          if (aan && vol) spreek(t('lijstVol', { lijst: vol.naam, n: EIGEN_PER_LIJST }));
          return;
        }
        rij.setAttribute('aria-pressed', String(aan));
        var lijst = leesEigen().filter(function (l) { return l.id === rij.getAttribute('data-lijst'); })[0];
        if (lijst) {
          rij.querySelector('.sentir-blad__aantal').textContent = telTekst(gelijsteIds(lijst).length);
          vulCover(rij.querySelector('.sentir-blad__cover'), gelijsteIds(lijst), 1);
          spreek(t(aan ? 'inX' : 'uitX', { lijst: lijst.naam }));
        }
        return;
      }
      var idee = event.target.closest('.sentir-blad__idee');
      if (idee) {
        var concept = CONCEPTEN.filter(function (c) { return c.concept === idee.getAttribute('data-concept'); })[0];
        if (concept) nieuweLijstGemaakt(maakLijst(concept.naam, concept.concept, bladProduct));
      }
    });

    blad.querySelector('[data-blad-form]').addEventListener('submit', function (event) {
      event.preventDefault();
      var veld = blad.querySelector('#sentir-blad-naam');
      if (!veld.value.trim()) { veld.focus(); return; }
      nieuweLijstGemaakt(maakLijst(veld.value, null, bladProduct));
      veld.value = '';
    });

    blad.querySelector('.sentir-blad__paneel').setAttribute('tabindex', '-1');
  }

  /* Zolang het venster open is, op document-niveau: ook als de focus na een klik op tekst in het paneel naar <body>
   * viel, werken Esc en Tab nog (review 5 nov). Tab blijft in het venster. */
  function toetsInBlad(event) {
    if (!blad || blad.hidden || !blad.classList.contains('is-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); sluitBlad(); return; }
    if (event.key !== 'Tab') return;
    var paneel = blad.querySelector('.sentir-blad__paneel');
    var focusbaar = Array.prototype.filter.call(
      paneel.querySelectorAll('button, input, a[href]'),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
    if (!focusbaar.length) { event.preventDefault(); paneel.focus(); return; }
    var eerste = focusbaar[0];
    var laatste = focusbaar[focusbaar.length - 1];
    var binnen = paneel.contains(document.activeElement);
    if (!binnen) { event.preventDefault(); (event.shiftKey ? laatste : eerste).focus(); return; }
    if (event.shiftKey && document.activeElement === eerste) { event.preventDefault(); laatste.focus(); }
    else if (!event.shiftKey && document.activeElement === laatste) { event.preventDefault(); eerste.focus(); }
  }

  function spreek(tekst) {
    var live = blad && blad.querySelector('[data-blad-live]');
    if (live) live.textContent = tekst;
  }

  function nieuweLijstGemaakt(lijst) {
    if (!lijst) { spreek(t('maxLijsten', { n: EIGEN_MAX })); return; }
    if (!bladProduct) {
      // vanaf 'Nieuwe lijst' op de favorietenpagina: venster dicht en meteen naar de nieuwe lijst
      sluitBlad(true);
      try { window.dispatchEvent(new CustomEvent('sentir:favlijst-kies', { detail: { id: lijst.id } })); } catch (fout) {}
      return;
    }
    tekenBlad();
    spreek(t('lijstGemaakt', { lijst: lijst.naam }));
    var rij = blad.querySelector('.sentir-blad__rij[data-lijst="' + lijst.id + '"]');
    if (rij) rij.focus();
  }

  function tekenBlad() {
    var eigen = leesEigen();
    var favorieten = perGeur(leesLijsten());
    var rijen = blad.querySelector('[data-blad-rijen]');
    rijen.textContent = '';
    eigen.forEach(function (lijst) {
      var ids = gelijsteIds(lijst, favorieten);
      var li = document.createElement('li');
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'sentir-blad__rij';
      knop.setAttribute('data-lijst', lijst.id);
      knop.setAttribute('aria-pressed', String(staatIn(bladProduct, lijst.id)));
      knop.innerHTML = '<span class="sentir-blad__cover"></span><span class="sentir-blad__tekst"><span class="sentir-blad__naam"></span>' +
        '<span class="sentir-blad__aantal"></span></span><span class="sentir-blad__vink">' + ICOON.vink + '</span>';
      knop.querySelector('.sentir-blad__naam').textContent = lijst.naam;
      knop.querySelector('.sentir-blad__aantal').textContent = telTekst(ids.length);
      vulCover(knop.querySelector('.sentir-blad__cover'), ids, 1);
      li.appendChild(knop);
      rijen.appendChild(li);
    });
    blad.querySelector('[data-blad-bestaand]').hidden = !bladProduct || !eigen.length;
    blad.querySelector('[data-blad-nieuwlabel]').hidden = !bladProduct;

    var ideeen = blad.querySelector('[data-blad-ideeen]');
    ideeen.textContent = '';
    CONCEPTEN.filter(function (c) {
      return !eigen.some(function (l) { return l.concept === c.concept || l.naam.toLowerCase() === c.naam.toLowerCase(); });
    }).forEach(function (c) {
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'sentir-blad__idee';
      knop.setAttribute('data-concept', c.concept);
      knop.innerHTML = ICOON.plus + '<span></span>';
      knop.querySelector('span').textContent = c.naam;
      ideeen.appendChild(knop);
    });
    blad.querySelector('[data-blad-ideelabel]').hidden = !ideeen.children.length;
    blad.querySelector('[data-blad-eigenlabel]').textContent = ideeen.children.length ? t('ofEigenNaam') : t('kiesNaam');
  }

  /* pid leeg = alleen een nieuwe lijst maken (de tegel 'Nieuwe lijst'). */
  function openBlad(pid, opener) {
    if (!blad) bouwBlad();
    bladProduct = pid || '';
    bladOpener = opener || document.activeElement;
    bladVoor = bladProduct ? JSON.stringify(leesEigen().filter(function (l) { return l.ids.indexOf(bladProduct) > -1; }).map(function (l) { return l.id; })) : '';
    blad.querySelector('.sentir-blad__titel').textContent = bladProduct ? t('opslaanInLijst') : t('nieuweLijst');
    var product = blad.querySelector('[data-blad-product]');
    product.hidden = !bladProduct;
    if (bladProduct) {
      var beeld = blad.querySelector('[data-blad-beeld]');
      beeld.removeAttribute('src');
      beeldVan(bladProduct).then(function (src) { if (src) beeld.src = src; });
      var naamEl = blad.querySelector('[data-blad-naam]');
      naamEl.textContent = '';
      naamVan(bladProduct).then(function (naam) { naamEl.textContent = naam; });
    }
    tekenBlad();
    spreek('');
    window.clearTimeout(bladSluitTimer); // snel opnieuw geopend: de vorige sluitanimatie mag hem niet verbergen
    document.addEventListener('keydown', toetsInBlad, true);
    blad.hidden = false;
    document.documentElement.classList.add('sentir-blad-open');
    window.requestAnimationFrame(function () {
      blad.classList.add('is-open');
      // Eerst een bestaande lijst, anders het eerste idee; het naamveld pas als er niets anders is (geen toetsenbord
      // dat vanzelf opent).
      var eerste = (bladProduct && blad.querySelector('.sentir-blad__rij')) ||
        blad.querySelector('.sentir-blad__idee') || blad.querySelector('#sentir-blad-naam');
      if (eerste) eerste.focus({ preventScroll: true });
    });
  }

  function sluitBlad(zonderMelding) {
    if (!blad || blad.hidden) return;
    blad.classList.remove('is-open');
    document.documentElement.classList.remove('sentir-blad-open');
    document.removeEventListener('keydown', toetsInBlad, true);
    window.clearTimeout(bladSluitTimer);
    bladSluitTimer = window.setTimeout(function () { blad.hidden = true; }, 220);
    if (bladOpener && bladOpener.focus && document.contains(bladOpener)) bladOpener.focus({ preventScroll: true });
    if (zonderMelding || !bladProduct) return;
    // Zoals 'Opgeslagen in …' op Pinterest: alleen als er iets veranderde.
    var nu = leesEigen().filter(function (l) { return l.ids.indexOf(bladProduct) > -1; });
    if (JSON.stringify(nu.map(function (l) { return l.id; })) === bladVoor) return;
    var pid = bladProduct;
    var acties = [];
    if (nu.length && !document.querySelector('[data-favpage]')) {
      acties.push({ label: nu.length === 1 ? t('bekijkLijst') : t('mijnFav'), href: favorietenUrl(nu.length === 1 ? nu[0].id : '') });
    }
    naamVan(pid).then(function (naam) {
      var wie = naam || t('dezeGeur');
      var tekst = !nu.length ? t('geenLijst', { naam: wie })
        : (nu.length === 1 ? t('inLijst', { naam: wie, lijst: nu[0].naam }) : t('inLijsten', { naam: wie, n: nu.length }));
      melding(tekst, { acties: acties });
    });
  }

  /* -- de favorietenpagina: rij met lijsten, filteren, en een knop op elke kaart -- */
  function startBorden() {
    var pagina = document.querySelector('[data-favpage]');
    var kop = pagina && pagina.querySelector('.scl-favhd');
    if (!kop) return;
    var actief = 'alle';
    var nieuwGevraagd = false;
    try {
      var gevraagd = new URLSearchParams(window.location.search).get('lijst');
      // 'nieuw' (de knop 'Nieuwe lijst' op het dashboard, account-4) is nooit een lijst-id: die zijn 'l' plus base36.
      if (gevraagd === 'nieuw') nieuwGevraagd = true;
      else if (gevraagd && /^[a-z0-9_-]{1,40}$/.test(gevraagd)) actief = gevraagd;
    } catch (fout) {}

    var strook = document.createElement('section');
    strook.className = 'sentir-borden';
    strook.setAttribute('aria-labelledby', 'sentir-borden-titel');
    strook.innerHTML =
      '<h2 class="sentir-borden__titel" id="sentir-borden-titel">' + t('mijnLijsten') + '</h2>' +
      '<div class="sentir-borden__rij" data-borden-rij></div>' +
      '<div class="sentir-borden__actief" data-borden-actief hidden>' +
        '<div class="sentir-borden__actiefkop"><h3 class="sentir-borden__naam" data-bord-titel></h3><span class="sentir-borden__aantal" data-bord-aantal></span></div>' +
        '<form class="sentir-borden__hernoem" data-bord-hernoemform hidden>' +
          '<label class="visually-hidden" for="sentir-bord-naam">' + t('nieuweNaam') + '</label>' +
          '<input id="sentir-bord-naam" type="text" maxlength="' + EIGEN_NAAM_MAX + '" autocomplete="off">' +
          '<button type="submit" class="sentir-borden__knop sentir-borden__knop--hoofd">' + t('bewaar') + '</button>' +
          '<button type="button" class="sentir-borden__knop sentir-borden__knop--link" data-bord-annuleer>' + t('annuleer') + '</button>' +
        '</form>' +
        '<div class="sentir-borden__acties" data-bord-acties>' +
          '<button type="button" class="sentir-borden__knop sentir-borden__knop--hoofd" data-bord-mand>' + t('allesMand') + '</button>' +
          '<button type="button" class="sentir-borden__knop" data-bord-hernoem>' + t('naamWijzigen') + '</button>' +
          '<button type="button" class="sentir-borden__knop" data-bord-deel>' + t('deelLijst') + '</button>' +
          '<button type="button" class="sentir-borden__knop sentir-borden__knop--link" data-bord-weg>' + t('lijstVerwijderen') + '</button>' +
        '</div>' +
        '<div class="sentir-borden__zeker" data-bord-zeker hidden>' +
          '<p class="sentir-borden__zekertekst" data-bord-zekertekst></p>' +
          '<button type="button" class="sentir-borden__knop sentir-borden__knop--hoofd" data-bord-weg-ja>' + t('jaWeg') + '</button>' +
          '<button type="button" class="sentir-borden__knop sentir-borden__knop--link" data-bord-weg-nee>' + t('annuleer') + '</button>' +
        '</div>' +
        '<p class="sentir-borden__tip" data-bord-tip hidden>' + t('tip') + '</p>' +
        '<p class="sentir-borden__leeg" data-bord-leeg hidden>' + t('leegLijst') + '</p>' +
      '</div>';
    kop.parentNode.insertBefore(strook, kop.nextSibling);
    var rij = strook.querySelector('[data-borden-rij]');
    var paneel = strook.querySelector('[data-borden-actief]');

    // Alleen de rasters van de pagina zelf: een gedeelde lijst (?gedeeld=) heeft zijn eigen kaarten (review 5 nov).
    function kaarten() {
      return Array.prototype.slice.call(pagina.querySelectorAll('[data-favgrid] .pcard[data-card]'));
    }

    function tegel(id, naam, ids, extraKlasse) {
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'sentir-bord' + (extraKlasse ? ' ' + extraKlasse : '');
      knop.setAttribute('data-bord', id);
      knop.setAttribute('aria-pressed', String(actief === id));
      knop.innerHTML = '<span class="sentir-bord__cover"></span><span class="sentir-bord__naam"></span><span class="sentir-bord__aantal"></span>';
      knop.querySelector('.sentir-bord__naam').textContent = naam;
      knop.querySelector('.sentir-bord__aantal').textContent = telTekst(ids.length);
      vulCover(knop.querySelector('.sentir-bord__cover'), ids, 3);
      return knop;
    }

    // Lege pagina zonder account: de accountregel nodigt uit om in te loggen (favorieten van een ander apparaat).
    var accountRegel = pagina.querySelector('.scl-favaccount');
    var accountOrigineel = accountRegel ? Array.prototype.slice.call(accountRegel.childNodes) : [];
    function tekenAccountRegel(leeg) {
      if (!accountRegel || klant) return;
      var login = accountOrigineel.filter(function (n) { return n.nodeName === 'A'; })[0];
      if (leeg && login) {
        accountRegel.textContent = t('eerderAccount');
        var link = document.createElement('a');
        link.href = login.getAttribute('href');
        link.textContent = t('logIn');
        accountRegel.appendChild(link);
        accountRegel.appendChild(document.createTextNode(t('omTerug')));
      } else if (!leeg && accountRegel.childNodes.length !== accountOrigineel.length) {
        accountRegel.textContent = '';
        accountOrigineel.forEach(function (n) { accountRegel.appendChild(n); });
      }
    }

    function teken(focusOp) {
      var favorieten = perGeur(leesLijsten());
      var alle = leesLijsten().fav;
      var eigen = leesEigen();
      tekenAccountRegel(!alle.length);
      if (actief !== 'alle' && !eigen.some(function (l) { return l.id === actief; })) actief = 'alle';
      strook.hidden = !alle.length;
      // Stond de focus op een tegel, dan staat hij na het opnieuw tekenen weer op die tegel (review 5 nov).
      var gefocust = rij.contains(document.activeElement) && document.activeElement.getAttribute('data-bord');
      if (!focusOp && gefocust) focusOp = gefocust;
      rij.textContent = '';
      rij.appendChild(tegel('alle', t('alleFav'), alle, 'sentir-bord--alle'));
      eigen.forEach(function (lijst) { rij.appendChild(tegel(lijst.id, lijst.naam, gelijsteIds(lijst, favorieten))); });
      var nieuw = document.createElement('button');
      nieuw.type = 'button';
      nieuw.className = 'sentir-bord sentir-bord--nieuw';
      nieuw.setAttribute('data-bord-nieuw', '');
      nieuw.innerHTML = '<span class="sentir-bord__cover">' + ICOON.plus + '</span><span class="sentir-bord__naam">' + t('nieuweLijst') + '</span><span class="sentir-bord__aantal">' + t('metIdeeen') + '</span>';
      rij.appendChild(nieuw);

      var lijst = eigen.filter(function (l) { return l.id === actief; })[0];
      var inLijst = lijst ? gelijsteIds(lijst, favorieten) : null;
      paneel.hidden = !lijst;
      if (lijst) {
        paneel.querySelector('[data-bord-titel]').textContent = lijst.naam;
        paneel.querySelector('[data-bord-aantal]').textContent = telTekst(inLijst.length);
        paneel.querySelector('[data-bord-leeg]').hidden = inLijst.length > 0;
        paneel.querySelector('[data-bord-mand]').hidden = !inLijst.length;
        paneel.querySelector('[data-bord-deel]').hidden = !inLijst.length;
        paneel.querySelector('[data-bord-tip]').hidden = inLijst.length < 2;
      }
      kaarten().forEach(function (kaart) {
        var pid = kaart.getAttribute('data-card');
        var verbergen = !!inLijst && inLijst.indexOf(pid) < 0;
        if (verbergen) kaart.setAttribute('data-bord-verborgen', '');
        else kaart.removeAttribute('data-bord-verborgen');
        var knop = kaart.querySelector('.sentir-lijstknop');
        if (knop) {
          var aantal = eigen.filter(function (l) { return l.ids.indexOf(pid) > -1; }).length;
          var kop = kaart.querySelector('h2, h3');
          var naam = (kop && kop.textContent.trim()) || kaart.getAttribute('data-title') || '';
          knop.classList.toggle('is-in-lijst', aantal > 0);
          knop.setAttribute('aria-label', aantal
            ? (aantal === 1 ? t('lijstAria1Bij', { naam: naam }) : t('lijstAriaNBij', { naam: naam, n: aantal }))
            : t('opslaanBij', { naam: naam }));
        }
      });
      if (focusOp) {
        var doel = rij.querySelector('[data-bord="' + focusOp + '"]') || (focusOp === 'nieuw' && rij.querySelector('[data-bord-nieuw]'));
        if (doel) doel.focus({ preventScroll: true });
      }
    }

    function kies(id, focus) {
      actief = id;
      try {
        var url = new URL(window.location.href);
        if (id === 'alle') url.searchParams.delete('lijst');
        else url.searchParams.set('lijst', id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (fout) {}
      teken(focus ? id : null);
    }

    function voegKnopToe(kaart) {
      if (kaart.querySelector('.sentir-lijstknop')) return;
      var plek = kaart.querySelector('.pcard-img') || kaart;
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'sentir-lijstknop';
      knop.innerHTML = ICOON.lijst;
      plek.appendChild(knop);
    }

    function bijwerken() {
      kaarten().forEach(voegKnopToe);
      teken();
    }

    rij.addEventListener('click', function (event) {
      if (event.target.closest('[data-bord-nieuw]')) { openBlad('', event.target.closest('[data-bord-nieuw]')); return; }
      var tegelEl = event.target.closest('[data-bord]');
      if (tegelEl) kies(tegelEl.getAttribute('data-bord'), true);
    });

    pagina.addEventListener('click', function (event) {
      var knop = event.target.closest('.sentir-lijstknop');
      if (!knop) return;
      event.preventDefault();
      event.stopPropagation();
      openBlad(knop.closest('.pcard').getAttribute('data-card'), knop);
    }, true);

    paneel.addEventListener('click', function (event) {
      var lijst = leesEigen().filter(function (l) { return l.id === actief; })[0];
      if (!lijst) return;
      if (event.target.closest('[data-bord-mand]')) {
        var knop = event.target.closest('[data-bord-mand]');
        var items = kaarten().filter(function (k) {
          var add = k.querySelector('[data-add]');
          return !k.hasAttribute('data-bord-verborgen') && k.getAttribute('data-variant') && !(add && add.disabled);
        }).map(function (k) { return { id: Number(k.getAttribute('data-variant')), quantity: 1 }; });
        if (!items.length) return;
        knop.disabled = true;
        var klaar = function () { knop.disabled = false; };
        if (window.SentirCart && typeof window.SentirCart.add === 'function') {
          window.SentirCart.add({ items: items }).then(klaar, function () { klaar(); melding(t('mislukt')); });
        } else {
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }).then(klaar, klaar);
        }
        return;
      }
      if (event.target.closest('[data-bord-deel]')) {
        deelLijst(lijst, event.target.closest('[data-bord-deel]'));
        return;
      }
      if (event.target.closest('[data-bord-hernoem]')) {
        var form = paneel.querySelector('[data-bord-hernoemform]');
        form.hidden = false;
        paneel.querySelector('[data-bord-acties]').hidden = true;
        var veld = form.querySelector('input');
        veld.value = lijst.naam;
        veld.focus();
        veld.select();
        return;
      }
      if (event.target.closest('[data-bord-annuleer]')) {
        paneel.querySelector('[data-bord-hernoemform]').hidden = true;
        paneel.querySelector('[data-bord-acties]').hidden = false;
        paneel.querySelector('[data-bord-hernoem]').focus();
        return;
      }
      // Verwijderen pas na een bevestiging in het paneel zelf (review 5 nov): de melding met 'Ongedaan maken' is
      // voor wie met het toetsenbord werkt niet goed te bereiken.
      if (event.target.closest('[data-bord-weg]')) {
        paneel.querySelector('[data-bord-zekertekst]').textContent = t('zekerWeg', { lijst: lijst.naam });
        paneel.querySelector('[data-bord-acties]').hidden = true;
        paneel.querySelector('[data-bord-zeker]').hidden = false;
        paneel.querySelector('[data-bord-weg-nee]').focus();
        return;
      }
      if (event.target.closest('[data-bord-weg-nee]')) {
        paneel.querySelector('[data-bord-zeker]').hidden = true;
        paneel.querySelector('[data-bord-acties]').hidden = false;
        paneel.querySelector('[data-bord-weg]').focus();
        return;
      }
      if (event.target.closest('[data-bord-weg-ja]')) {
        paneel.querySelector('[data-bord-zeker]').hidden = true;
        paneel.querySelector('[data-bord-acties]').hidden = false;
        var eigen = leesEigen();
        var plek = eigen.map(function (l) { return l.id; }).indexOf(lijst.id);
        eigen.splice(plek, 1);
        zetEigen(eigen);
        kies('alle', true);
        melding(t('verwijderd', { lijst: lijst.naam }), {
          acties: [{
            label: t('ongedaan'),
            doe: function () {
              var terug = leesEigen();
              terug.splice(Math.min(plek, terug.length), 0, lijst);
              zetEigen(terug);
              kies(lijst.id, true);
            },
          }],
        });
      }
    });

    paneel.querySelector('[data-bord-hernoemform]').addEventListener('submit', function (event) {
      event.preventDefault();
      var naam = event.target.querySelector('input').value.trim().slice(0, EIGEN_NAAM_MAX);
      var eigen = leesEigen();
      var lijst = eigen.filter(function (l) { return l.id === actief; })[0];
      if (lijst && naam) {
        lijst.naam = naam;
        zetEigen(eigen);
      }
      event.target.hidden = true;
      paneel.querySelector('[data-bord-acties]').hidden = false;
      teken();
      paneel.querySelector('[data-bord-hernoem]').focus();
    });

    window.addEventListener('sentir:favlijst-kies', function (event) { kies((event.detail && event.detail.id) || 'alle'); });
    ['sentir:favlijsten-changed', 'sentir:lists-changed', 'sentir:lists-sync'].forEach(function (naam) {
      window.addEventListener(naam, function () { window.setTimeout(teken, 0); });
    });
    window.addEventListener('storage', function (event) {
      if (event && (event.key === EIGEN_SLEUTEL || event.key === 'sentir-fav')) window.setTimeout(teken, 0);
    });
    if (window.MutationObserver) {
      var waarnemer = new MutationObserver(bijwerken);
      Array.prototype.forEach.call(pagina.querySelectorAll('[data-favgrid]'), function (raster) {
        waarnemer.observe(raster, { childList: true });
      });
    }
    bijwerken();
    toonGedeeld(pagina);

    // Vanaf het dashboard: meteen het venster voor een nieuwe lijst (de tegel staat op de telefoon vaak buiten beeld).
    // De parameter gaat eerst weg, zodat herladen of 'terug' het venster niet opnieuw opent.
    if (nieuwGevraagd) {
      try {
        var schoon = new URL(window.location.href);
        schoon.searchParams.delete('lijst');
        window.history.replaceState(window.history.state, '', schoon.toString());
      } catch (fout) {}
      var tegelNieuw = rij.querySelector('[data-bord-nieuw]');
      if (tegelNieuw && !strook.hidden) openBlad('', tegelNieuw);
    }
  }

  /* -- Een lijst delen (Thomas, 4 nov 2026: 'zoals Pinterest'): een link met de geuren en de naam. Op de telefoon via
   *    het deelmenu, anders gekopieerd. Wie de link opent ziet de geuren bovenaan de favorietenpagina en kan ze met
   *    één knop als eigen lijst bewaren (handig voor verlanglijstjes rond Sinterklaas en Kerst). -- */
  function deelLink(lijst) {
    var handles = lees('sentir-handles', {}) || {};
    var lijstHandles = gelijsteIds(lijst).map(function (pid) { return handles[pid] || handleVan(pid); }).filter(function (h) {
      return /^[a-z0-9-]{1,120}$/.test(h || '');
    }).slice(0, 30);
    var pad = favorietenUrl().replace(/\?.*$/, '');
    var basis = /^https?:/.test(pad) ? pad : window.location.origin + pad;
    return basis + '?gedeeld=' + encodeURIComponent(lijstHandles.join(',')) + '&naam=' + encodeURIComponent(lijst.naam);
  }

  function deelLijst(lijst, knop) {
    var url = deelLink(lijst);
    var tekst = t('deelTekst', { lijst: lijst.naam });
    if (navigator.share && window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: lijst.naam, text: tekst, url: url }).catch(function () {});
      return;
    }
    var klaar = function () { melding(t('gekopieerd', { lijst: lijst.naam })); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(klaar, function () { window.prompt(t('kopieer'), url); });
    } else {
      window.prompt(t('kopieer'), url);
    }
  }

  function toonGedeeld(pagina) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (fout) { return; }
    var ruw = params.get('gedeeld');
    if (!ruw) return;
    var handles = ruw.split(',').filter(function (h) { return /^[a-z0-9-]{1,120}$/.test(h); }).slice(0, 30);
    if (!handles.length) return;
    var naam = (params.get('naam') || t('gedeeldeLijst')).trim().slice(0, EIGEN_NAAM_MAX) || t('gedeeldeLijst');
    var wrap = pagina.querySelector('.scl-wrap');
    var kop = pagina.querySelector('.scl-favhd');
    if (!wrap || !kop) return;

    var blok = document.createElement('section');
    blok.className = 'sentir-gedeeld';
    blok.setAttribute('aria-labelledby', 'sentir-gedeeld-titel');
    blok.innerHTML =
      '<p class="sentir-gedeeld__boven">' + t('gedeeldeLijst') + '</p>' +
      '<h2 class="sentir-gedeeld__titel" id="sentir-gedeeld-titel"></h2>' +
      '<p class="sentir-gedeeld__tekst">' + t('gedeeldTekst') + '</p>' +
      '<div class="sentir-gedeeld__acties">' +
        '<button type="button" class="sentir-borden__knop sentir-borden__knop--hoofd" data-gedeeld-bewaar>' + t('bewaarAlsLijst') + '</button>' +
        '<button type="button" class="sentir-borden__knop" data-gedeeld-mand>' + t('allesMand') + '</button>' +
      '</div>' +
      '<div class="scl-grid sentir-gedeeld__raster" data-gedeeld-raster aria-busy="true"></div>';
    blok.querySelector('.sentir-gedeeld__titel').textContent = naam;
    kop.parentNode.insertBefore(blok, kop.nextSibling);
    var raster = blok.querySelector('[data-gedeeld-raster]');
    raster.innerHTML = handles.map(function () { return '<div class="scl-favskel" aria-hidden="true"></div>'; }).join('');

    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=sentir-fav-kaart', { credentials: 'same-origin' })
        .then(function (antwoord) { return antwoord.ok ? antwoord.text() : ''; })
        .then(function (html) {
          var tijdelijk = document.createElement('div');
          tijdelijk.innerHTML = html;
          return tijdelijk.querySelector('.pcard');
        })
        .catch(function () { return null; });
    })).then(function (kaarten) {
      raster.innerHTML = '';
      kaarten.forEach(function (kaart, i) {
        if (!kaart) return;
        kaart.setAttribute('data-gedeeld-handle', handles[i]);
        raster.appendChild(kaart);
      });
      raster.removeAttribute('aria-busy');
      if (!raster.children.length) blok.parentNode.removeChild(blok);
      tekenHartjesGedeeld();
    });

    function gedeeldeIds() {
      return Array.prototype.map.call(raster.querySelectorAll('.pcard[data-card]'), function (k) { return k.getAttribute('data-card'); });
    }

    /* De favorietenpagina zet na elke wijziging alle hartjes in haar gebied opnieuw (paintMarks), ook deze; die kent
     * de gedeelde kaarten niet en zet ze uit. Daarom herstellen ze zichzelf. Alleen bij verschil schrijven, anders
     * roept de waarnemer zichzelf eindeloos aan. */
    function tekenHartjesGedeeld() {
      var favorieten = perGeur(leesLijsten());
      Array.prototype.forEach.call(raster.querySelectorAll('.pcard[data-card] [data-mark="fav"]'), function (hart) {
        var aan = String(favorieten[hart.closest('.pcard').getAttribute('data-card')] === 'fav');
        if (hart.getAttribute('aria-pressed') !== aan) hart.setAttribute('aria-pressed', aan);
        var label = t('favoriet');
        if (hart.getAttribute('aria-label') !== label) hart.setAttribute('aria-label', label);
      });
    }
    if (window.MutationObserver) {
      new MutationObserver(tekenHartjesGedeeld).observe(raster, { attributes: true, attributeFilter: ['aria-pressed'], subtree: true });
    }

    function bewaarHandles() {
      var map = lees('sentir-handles', {}) || {};
      Array.prototype.forEach.call(raster.querySelectorAll('.pcard[data-card]'), function (k) {
        map[k.getAttribute('data-card')] = k.getAttribute('data-gedeeld-handle');
      });
      zet('sentir-handles', map);
    }

    // De favorietenpagina reageert niet op hartjes buiten haar eigen lijsten; hier doen we het zelf.
    raster.addEventListener('click', function (event) {
      var hart = event.target.closest('[data-mark="fav"]');
      if (!hart) return;
      event.preventDefault();
      event.stopPropagation();
      var pid = hart.closest('.pcard').getAttribute('data-card');
      bewaarHandles();
      if (isFavoriet(pid)) {
        var lijsten = leesLijsten();
        lijsten.fav = lijsten.fav.filter(function (x) { return x !== pid; });
        zet('sentir-fav', lijsten.fav);
        try { window.dispatchEvent(new CustomEvent('sentir:lists-changed')); } catch (fout) {}
      } else {
        maakFavoriet(pid);
      }
      tekenHartjesGedeeld();
      try { window.dispatchEvent(new StorageEvent('storage', { key: 'sentir-fav' })); } catch (fout2) {}
    }, true);

    blok.addEventListener('click', function (event) {
      if (event.target.closest('[data-gedeeld-bewaar]')) {
        bewaarHandles();
        var ids = gedeeldeIds();
        var lijst = null;
        ids.forEach(function (pid, i) {
          if (i === 0) lijst = maakLijst(naam, null, pid);
          else if (lijst) zetInLijst(lijst.id, pid, true);
        });
        tekenHartjesGedeeld();
        try { window.dispatchEvent(new StorageEvent('storage', { key: 'sentir-fav' })); } catch (fout) {}
        if (lijst) {
          melding(t('nuBijLijsten', { lijst: lijst.naam }), { acties: [{ label: t('bekijkLijst'), doe: function () {
            try { window.dispatchEvent(new CustomEvent('sentir:favlijst-kies', { detail: { id: lijst.id } })); } catch (fout2) {}
            var strook = pagina.querySelector('.sentir-borden');
            if (strook) strook.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } }] });
        }
        return;
      }
      if (event.target.closest('[data-gedeeld-mand]')) {
        var items = Array.prototype.filter.call(raster.querySelectorAll('.pcard[data-card]'), function (k) {
          var add = k.querySelector('[data-add]');
          return k.getAttribute('data-variant') && !(add && add.disabled);
        }).map(function (k) { return { id: Number(k.getAttribute('data-variant')), quantity: 1 }; });
        if (!items.length) return;
        if (window.SentirCart && typeof window.SentirCart.add === 'function') {
          window.SentirCart.add({ items: items }).catch(function () { melding(t('mislukt')); });
        } else {
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
        }
      }
    });
  }

  /* ------------------------------------------------------- 7. productpagina -- */

  /*
   * Een hartje naast de titel op de productpagina (optimalisatieronde 5 nov 2026): tot nu toe kon je alleen vanuit de
   * Lijst bewaren. De geurpagina's zijn PageFly-pagina's (titel in #product-page-title, twee keer: telefoon en
   * desktop); daarnaast Dawn (.product__title) en de bundelpagina (.bundle-product__title). Het product komt uit
   * Shopify's eigen paginagegevens (ShopifyAnalytics.meta.product). Niet op de 60 ml-fles: daar kies je eerst een geur.
   */
  var HART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5C7.2 16.3 3.5 13.2 3.5 9.4 3.5 6.9 5.4 5 7.8 5c1.7 0 3.2.9 4.2 2.5C13 5.9 14.5 5 16.2 5c2.4 0 4.3 1.9 4.3 4.4 0 3.8-3.7 6.9-8.5 11.1z"/></svg>';

  function startPdpHartje() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (!meta || !meta.id || !meta.handle || meta.handle === '60-ml-bundle') return;
    var pid = String(meta.id);
    var titels = document.querySelectorAll('[id="product-page-title"], .product__title, .bundle-product__title');
    if (!titels.length && /^\d+$/.test(pid)) {
      // PageFly-setpagina's (womens-/mens-autumn-set, review collectie-pdp-13): de titel is een H3 van PageFly. Alleen
      // die met het id van dit product; op de geurpagina's zijn de andere ProductTitle-koppen upsells van andere geuren.
      titels = document.querySelectorAll('[data-pf-type="ProductTitle"][data-product-id="' + pid + '"]');
    }
    if (!titels.length) return;
    var knoppen = [];
    Array.prototype.forEach.call(titels, function (titel) {
      if (titel.querySelector('.sentir-pdp-hart')) return;
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'sentir-pdp-hart wg-notranslate';
      knop.setAttribute('translate', 'no');
      knop.setAttribute('data-wg-notranslate', '');
      knop.innerHTML = HART_SVG;
      // In de titel zelf (na de tekst), zodat hij in elke opmaak naast de naam staat.
      titel.appendChild(knop);
      knoppen.push(knop);
    });

    function teken() {
      var aan = isFavoriet(pid);
      knoppen.forEach(function (knop) {
        knop.setAttribute('aria-pressed', String(aan));
        knop.setAttribute('aria-label', t('pdpAan'));
        knop.title = aan ? t('pdpTitelAan') : t('pdpAan');
      });
    }

    knoppen.forEach(function (knop) {
      knop.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var handles = lees('sentir-handles', {}) || {};
        handles[pid] = meta.handle;
        zet('sentir-handles', handles);
        var naam = (titels[0].textContent || '').trim();
        if (isFavoriet(pid)) {
          var lijsten = leesLijsten();
          lijsten.fav = lijsten.fav.filter(function (x) { return x !== pid; });
          zet('sentir-fav', lijsten.fav);
          try { window.dispatchEvent(new CustomEvent('sentir:lists-changed')); } catch (fout) {}
          teken();
          melding(t('uitFav', { naam: naam || t('dezeGeur') }));
          return;
        }
        maakFavoriet(pid);
        teken();
        melding(t('inFav', { naam: naam || t('dezeGeur') }), {
          acties: [
            { label: t('voegToe'), doe: function () { openBlad(pid, knop); } },
            { label: t('mijnFav'), href: favorietenUrl() },
          ],
          accountTip: !klant && !accountTipGetoond && (accountTipGetoond = true),
        });
      });
    });
    ['sentir:lists-changed', 'sentir:lists-sync'].forEach(function (naam) { window.addEventListener(naam, teken); });
    window.addEventListener('storage', function (event) { if (event && event.key === 'sentir-fav') teken(); });
    teken();
  }

  /* ------------------------------------------------------------ 8. chatkaarten -- */

  /*
   * De productkaarten in de chat (assets/sentir-chat.js, .sch-pk) zijn dezelfde kaarten als in de Lijst, met het hartje,
   * de bladwijzer en het kruisje. In de chat zelf verbergt sentir-chat-kaart.css die hele rij (.sch .sch-pk .rail);
   * staat hij ooit aan, dan werkt het hartje hier als overal (opslaan, melding, account) en blijven bladwijzer en
   * kruisje verborgen. De chat komt later in de pagina dan dit script, dus eerst wachten tot hij er is en dan zijn
   * gesprek (.sch-log) volgen.
   */
  function startChatKaarten() {
    function pid(kaart) { return kaart.getAttribute('data-card') || ''; }
    function tekenChatHartjes() {
      Array.prototype.forEach.call(document.querySelectorAll('.sch-pk .pcard[data-card] [data-mark="fav"]'), function (hart) {
        var aan = String(isFavoriet(pid(hart.closest('.pcard'))));
        if (hart.getAttribute('aria-pressed') !== aan) hart.setAttribute('aria-pressed', aan);
        if (hart.getAttribute('aria-label') !== t('favoriet')) hart.setAttribute('aria-label', t('favoriet'));
      });
    }
    document.addEventListener('click', function (event) {
      var knop = event.target.closest && event.target.closest('.sch-pk .pcard [data-mark]');
      if (!knop) return;
      event.preventDefault();
      event.stopPropagation();
      if (knop.getAttribute('data-mark') !== 'fav') return;
      var kaart = knop.closest('.pcard');
      var id = pid(kaart);
      var kop = kaart.querySelector('h2, h3');
      zetFavoriet(id, !isFavoriet(id), {
        handle: kaart.getAttribute('data-handle') || kaart.getAttribute('data-sch-handle') || '',
        naam: kop ? kop.textContent.trim() : '',
        opener: knop,
      });
      tekenChatHartjes();
    }, true);
    ['sentir:lists-changed', 'sentir:lists-sync'].forEach(function (naam) { window.addEventListener(naam, tekenChatHartjes); });
    if (!window.MutationObserver) return;
    function volgGesprek(chat) {
      var log = chat.querySelector('.sch-log') || chat;
      new MutationObserver(tekenChatHartjes).observe(log, { childList: true, subtree: true });
      tekenChatHartjes();
    }
    var chat = document.querySelector('[data-sentir-chat]');
    if (chat) { volgGesprek(chat); return; }
    var wachter = new MutationObserver(function () {
      var gevonden = document.querySelector('[data-sentir-chat]');
      if (!gevonden) return;
      wachter.disconnect();
      volgGesprek(gevonden);
    });
    wachter.observe(document.body, { childList: true });
  }

  function start() {
    // Elk onderdeel apart: een fout in één (bijv. een vreemde pagina-opbouw) mag de rest niet tegenhouden.
    [opruimenNaUitloggen, maakMeldingEl, tekenHartje, startKoppel, startChatKaarten, startNotities, startFlush, startKlaviyo, startBorden, startPdpHartje]
      .forEach(function (stap) {
        try { stap(); } catch (fout) { if (window.console) window.console.warn('sentir-favorieten:', fout); }
      });
  }


  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
